<template>
  <div id="adminCrmItems">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ crm }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Prodotti</router-link>
      </li>
    </ol>
    <div class="container-fluid card-title-admin">
      <div class="row">
        <div class="col-6 align-self-center">
          <h1>Prodotti</h1>
        </div>
        <div class="col-6 text-right align-self-center" v-if="rowIdSelected > 0">
          <label class="label-name" style="margin-bottom: 0px">Online</label>
          <label
            class="switch switch-pill switch-primary"
            style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"
          >
            <input
              type="checkbox"
              class="switch-input"
              id="idAssociationCodeImage"
              :checked="checkOnlineItem"
              @change="onChangeCheckOnlineItem"
            />
            <span class="switch-slider" data-on data-off></span>
          </label>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane active" id="tabTable" role="tabpanel">
            <div class="row align-btns" style="width: 80%">
              <div class="col-lg-6">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onNewCategories"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
                <button
                  id="btnSave"
                  type="button"
                  class="btn btn-success"
                  @click="confirmSaveCategories"
                  :disabled="disableButton"
                >
                  <i class="fa fa-floppy-o"></i>
                  <span>{{ save }}</span>
                </button>
                 <button
                            id="btnDelete"
                            type="button"
                            class="btn btn-danger"
                            @click="confirmDeleteCategories"
                            :disabled="disableButton"
                          >
                            <i class="fa fa-trash trashtable"></i>
                            <span>{{ del }}</span>
                          </button>
              </div>
              <div class="col-3 language" style="visibility:hidden;">
                <select2
                  id="select_AdminPagesView_IdLanguage"
                  ref="select_AdminPagesView_IdLanguage"
                  class="form-control nopadding language"
                 
                  :filterable="false"
                  service="languages"
                  v-model="pageValueSelected.languagePageSetting.idLanguage"
                  :default="defaultLanguageOptions"
                  :change="languageChange"
                  placeholder="Lingua"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <bootstrapTable
                  :configurations="tableConfiguration"
                  :datas="tableData"
                  id="tableCategories"
                  :onCheck="onTableCheckCategories"
                  :onCheckAll="onTableCheckCategories"
                  :onUncheck="onTableCheckCategories"
                  :onUncheckAll="onTableCheckCategories"
                  ref="tableCategories"
                  :results="tableResult"
                ></bootstrapTable>
              </div>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabDetail" role="tabpanel">
            <!--div class="card-header">{{ newTitleArticoli }}</!--div-->
            <div class="row">
              <div class="col-sm-12">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <button
                      id="tabAdminNewsletterCampaign"
                      class="nav-link active"
                      type="button"
                      data-toggle="tab"
                      href="#tabAdminNewsletterCampaignDetailTab"
                      role="tab"
                      aria-controls="tabAdminNewsletterCampaignDetailTab"
                      v-on:click="onItemRelatedDisableTab"
                    >
                      <span>Dati</span>
                    </button>
                  </li>

                  <li class="nav-item" v-if="rowIdSelected>0">
                    <button
                      id="tabAdminListCategories"
                      class="nav-link"
                      type="button"
                      data-toggle="tab"
                      href="#tabAdminListCategoriesTab"
                      role="tab"
                      aria-controls="tabAdminListCategoriesTab"
                      v-on:click="onItemListCategoriesTab"
                    >
                      <span>Categorie</span>
                    </button>
                  </li>

                  <li class="nav-item" v-if="rowIdSelected>0">
                    <button
                      id="tabAdminImages"
                      class="nav-link"
                      type="button"
                      data-toggle="tab"
                      href="#tabAdminImagesTab"
                      role="tab"
                      aria-controls="tabAdminImagesTab"
                      v-on:click="onItemAdminImagesTab"
                    >
                      <span>Immagini</span>
                    </button>
                  </li>

                  <li class="nav-item" v-if="rowIdSelected>0">
                    <button
                      id="tabAdminPriceListButton"
                      type="button"
                      class="nav-link"
                      data-toggle="tab"
                      href="#tabAdminPriceList"
                      role="tab"
                      aria-controls="tabAdminPriceList"
                      v-on:click="onTabAdminPriceList"
                    >
                      <span>Vendite</span>
                    </button>
                  </li>

                  <li class="nav-item" v-if="rowIdSelected>0">
                    <button
                      id="tabAdminItemsAttributeButton"
                      type="button"
                      class="nav-link"
                      data-toggle="tab"
                      href="#tabAdminItemsAttribute"
                      role="tab"
                      aria-controls="tabAdminItemsAttribute"
                      v-on:click="onTabAdminItemsAttribute"
                    >
                      <span>Attributi</span>
                    </button>
                  </li>

                  <li class="nav-item" v-if="rowIdSelected>0">
                    <button
                      id="tabAdminItemsOptionalButton"
                      type="button"
                      class="nav-link"
                      data-toggle="tab"
                      href="#tabAdminItemsOptional"
                      role="tab"
                      aria-controls="tabAdminItemsOptional"
                      v-on:click="onTabAdminItemsOptional"
                    >
                      <span>Optional</span>
                    </button>
                  </li>

                  <li class="nav-item" v-if="rowIdSelected>0">
                    <button
                      id="tabAdminItemRelated"
                      type="button"
                      class="nav-link"
                      data-toggle="tab"
                      href="#tabAdminItedRelatedList"
                      role="tab"
                      aria-controls="tabAdminItedRelatedList"
                      v-on:click="onItemRelatedTab"
                    >
                      <span>Correlati</span>
                    </button>
                  </li>

                  <li class="nav-item" v-if="rowIdSelected>0">
                    <button
                      id="tabAdminItemsTranslationButton"
                      type="button"
                      class="nav-link"
                      data-toggle="tab"
                      href="#tabAdminItemsTranslation"
                      role="tab"
                      aria-controls="tabAdminItemsTranslation"
                      v-on:click="onTabAdminItemstranslation"
                    >
                      <span>Traduzioni</span>
                    </button>
                  </li>
                </ul>

                <div class="tab-content">
                  <!-- GENERALE -->
                  <div
                    class="card-body active tab-pane"
                    id="detailItem"
                    role="tabpanel"
                    style="padding-left: 25px;padding-right: 25px;">
                    <div class="row">
                     <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                      <pageDetail
                        functions="adminCrmItems"
                        :configurations="DetailDateConfiguration"
                        :jsonValue="detailData"
                      ></pageDetail>
                    </div>
                    <div class="row">
                      <div class="col-12 text-right">
                        <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="confirmCancelNewCategories"
                        >
                        <i class="fa fa-times"></i>&nbsp;
                          {{ cancel }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-success"
                          @click="confirmSaveNewCategories"
                        >
                        <i class="fa fa-floppy-o"></i>&nbsp;
                          {{ save }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- END GENERALE -->
                  <!-- ATTRIBUTI -->
                  <div
                    class="card-body tab-pane"
                    id="DetailAttribute"
                    role="tabpanel"
                  >
                    <div class="row">
                      <div class="col-6">
                        <pageDetail
                          functions="adminCrmItemsAttribute"
                          :configurations="DetailAttributeConfiguration"
                          :jsonValue="detailData"
                        ></pageDetail>
                      </div>
                      <div class="col-6">
                        <!-- GESTIONE SUPPORTI -->
                        <div class="row">
                          <div class="col-12 text-left">
                            <h3 style="font-size: 20px;font-weight: lighter;color: #303c54;">Supporti</h3>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 text-left">
                            <div v-for="support in supports" v-bind:key="support.id" style="padding-bottom:.3rem;">
                              <label
                                class="switch switch-pill switch-primary"
                                style="margin: 2px; margin-bottom: -2px; vertical-align: bottom"
                              >
                                <input
                                  type="checkbox"
                                  class="switch-input"
                                  id="idAssociationCodeImage"
                                  :checked="support.checked"
                                  @change="onChangeSupportItem(support.id)"
                                />
                                <span class="switch-slider" data-on data-off></span>
                              </label>
                              <label class="label-name" style="margin-bottom: 0px">{{ support.description }}</label>
                            </div>
                          </div>
                        </div>
                        <!-- END GESTIONE SUPPORTI -->
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-8">
                        <div id="div-cont-img-all"></div>
                        <div
                          class="row"
                          v-for="file in files"
                          v-bind:key="file.id"
                        >
                          <input
                            type="hidden"
                            :id="'imgBase64' + file.id"
                            :name="'imgBase64' + file.id"
                            :value="file.base64"
                          />
                          <input
                            type="hidden"
                            :id="'imgName' + file.id"
                            :name="'imgName' + file.id"
                            :value="file.name"
                          />
                          <input
                            type="hidden"
                            :id="'img' + file.id"
                            :name="'img' + file.id"
                            :value="file.name"
                          />
                          <input
                            type="hidden"
                            :id="'idAttachment' + file.id"
                            :name="'idAttachment' + file.id"
                            :value="file.id"
                          />
                          <div class="col-1">
                            <button
                              class="btn btn-light fa fa-times"
                              @click="RemoveFileDb(file.idAttachment, file)"
                              title="Remove"
                            ></button>
                          </div>
                          <div class="col-2">
                            <button
                              class="btn btn-primary"
                              @click="getImage(file.idAttachment)"
                            >
                              Seleziona
                            </button>
                          </div>
                          <div class="col-6">
                            <label>{{ file.name }}</label>
                          </div>
                          <div class="col-2">
                            <label>({{ file.size }} Kb)</label>
                          </div>
                          <div class="col-1">
                            <button
                            type="button"
                              class="btn btn-danger"
                              @click="removeFile(file.idAttachment, file)"
                              title="Remove"
                            > <i
                            class="fa fa-trash" style="color: #fff"></i></button>
                          </div>
                        </div>

                        <div class="col-12 text-right">
                          <i
                            class="fa fa-plus-circle"
                             style="font-size: 22px;cursor:pointer;"

                            id="add-img-all"
                            @click="addImg"
                          ></i>
                        </div>
                      </div>
                      <div class="col-4">
                        <label
                          id="move-file"
                          v-cloak
                          @drop.prevent="handleFileInput"
                          @dragover.prevent
                          class="custom-file-upload"
                          style="padding: 70px"
                        >
                          <input
                            id="imgAttachmentAgg"
                            type="file"
                            name="file-input"
                            multiple="True"
                            @change="handleFileInput"
                          />
                          SFOGLIA/UPLOAD AREA
                        </label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 text-right">
                        <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="confirmCancelNewCategories"
                        ><i class="fa fa-times"></i>&nbsp;
                          {{ cancel }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-success"
                          @click="confirmSaveNewCategories"
                        ><i class="fa fa-floppy-o"></i>&nbsp;
                          {{ save }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- END ATTRIBUTI -->

                  <!-- TAB CATEGORIE -->
                  <div
                    class="card-body tab-pane"
                    id="DetailListCategories"
                    role="tabpanel"
                  >
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-4"
                        style="background: #fafafa; padding-top: 15px"
                      >
                        <treeCategories
                          :listCategories="listTreeCategories"
                        ></treeCategories>
                      </div>
                      <div class="col-sm-12 col-md-8">
                        <div
                          class="listDetailCategories"
                          v-for="detailListCategories in arrayListCategoriesDetail"
                          v-bind:key="detailListCategories.id"
                        >
                          <div class="row">
                            <div class="col-4 align-self-center">
                              <label>{{
                                detailListCategories.descriptionCategory
                              }}</label>
                            </div>
                            <div class="col-2 align-self-center">
                              <label>Ordinamento</label>
                              <input
                                class="form-control"
                                type="number"
                                @change="
                                  updateOrderCategoryItem(
                                    detailListCategories.id
                                  )
                                "
                                :id="'inputOrder' + detailListCategories.id"
                                :value="detailListCategories.order"
                                :name="'inputOrder' + detailListCategories.id"
                              />
                            </div>
                            <div class="col-6 text-center align-self-center">
                              <label
                                >{{
                                  detailListCategories.descriptionPrecItem
                                }}
                                ({{
                                  detailListCategories.orderPrecItem
                                }})</label
                              >
                              <h5>
                                {{ detailListCategories.descriptionItem }}
                              </h5>
                              <label
                                >{{
                                  detailListCategories.descriptionPostItem
                                }}
                                ({{
                                  detailListCategories.orderPostItem
                                }})</label
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-top: 15px">
                      <div class="col-12 text-right">
                        <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="confirmCancelNewCategories"
                        ><i class="fa fa-chevron-left"></i>
                          Indietro
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- END TAB CATEGORIE -->
                  <!-- TAB IMAGES -->
                  <div
                    class="card-body tab-pane"
                    id="DetailImages"
                    role="tabpanel"
                  >
                    <div
                      class="row div-row-img-item"
                      style="border-bottom: 4px dashed #ededed"
                      v-if="!checkAssociationCodeImage"
                    >
                      <div class="col-9">
                        <div class="row div-row-img-item">
                          <div class="col-5 align-self-center">
                            <label>Immagine Principale</label><br />
                            <button
                              class="btn btn-primary"
                              @click="selectImageExist(itemImages.id, true)"
                            >
                              SELEZIONA
                            </button>
                            <label class="label-name">{{
                              itemImages.imgName
                            }}</label>
                          </div>
                          <div class="col-2 align-self-center">
                            <label>Anteprima</label><br />
                            <a class="img" :href="itemImages.img"><img :src="itemImages.img" /></a>
                          </div>
                          <div class="col-4 align-self-center">
                            <label style="margin-top: 15px;" v-if="itemImages.weight != '0 bytes'">
                              <i class="fa fa-balance-scale fa-stack" aria-hidden="true"></i> {{ itemImages.weight }}
                            </label><br>
                            <label v-if="itemImages.width>0 || itemImages.width!=0">
                              <i class="fa fa-arrows-alt fa-stack" aria-hidden="true"></i>{{ itemImages.width }} x {{ itemImages.height }} pixel
                            </label>
                          </div>
                          <div class="col-1 align-self-center text-right">
                            <i class="fa fa-trash btn btn-danger delete" style="color:#fff; margin-left: 3px;" @click="deleteImage(true, itemImages.id)"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 align-self-center">
                        <label
                          for="imgPrincipalItems"
                          class="custom-file-upload"
                          v-cloak
                          @drop.prevent="onChangeImagePrincipalNew"
                          @dragover.prevent
                        >
                          SFOGLIA / UPLOAD AREA
                        </label>
                        <input
                          type="file"
                          id="imgPrincipalItems"
                          name="imgPrincipalItems"
                          @change="onChangeImagePrincipalNew"
                        />
                      </div>
                    </div>
                    <div
                      class="row div-row-img-item"
                      v-if="!checkAssociationCodeImage"
                    >
                      <div class="col-9 align-self-center">
                        <div class="row div-row-img-item">
                          <div class="col-7">
                            <label>Immagine Aggiuntive</label>
                          </div>
                          <div class="col-5">
                            <label>Ordinamento</label>
                          </div>
                        </div>
                        <div
                          class="row div-row-img-item"
                          v-for="itemImageAgg in itemImages.imgAgg"
                          v-bind:key="itemImageAgg.id"
                        >
                          <div class="col-5 align-self-center">
                            <button
                              class="btn btn-primary"
                              @click="selectImageExist(itemImageAgg.id, false)"
                            >
                              SELEZIONA
                            </button>
                            <label class="label-name">{{
                              itemImageAgg.imgName
                            }}</label>
                          </div>
                          <div class="col-2 align-self-center">
                            <a class="img" :href="itemImageAgg.img"> <img :src="itemImageAgg.img" /></a>
                          </div>
                          <div class="col-2 align-self-center">
                            <input
                              type="number"
                              @change="onChangeOrderImagePhoto(itemImageAgg.id)"
                              class="form-control"
                              :value="itemImageAgg.order"
                              :id="'inputOrderImgAgg' + itemImageAgg.id"
                              :name="'inputOrderImgAgg' + itemImageAgg.id"
                            />
                          </div>
                          <div class="col-2 align-self-center">
                            <label style="margin-top: 15px;" v-if="itemImageAgg.weight != '0 bytes'">
                              <i class="fa fa-balance-scale fa-stack" aria-hidden="true"></i> {{ itemImageAgg.weight }}
                            </label><br>
                            <label v-if="itemImageAgg.width>0 || itemImageAgg.width!=0">
                              <i class="fa fa-arrows-alt fa-stack" aria-hidden="true"></i>{{ itemImageAgg.width }} x {{ itemImageAgg.height }} pixel
                            </label>
                          </div>
                          <div class="col-1 align-self-center">
                            <i
                              style="color:#fff;"
                              class="fa fa-trash btn btn-danger"
                              @click="deleteImage(false, itemImageAgg.id)"
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 align-self-center">
                        <label
                          for="imgPrincipalAgg"
                          class="custom-file-upload"
                          style="padding: 70px"
                          v-cloak
                          @drop.prevent="onChangeImageAgg"
                          @dragover.prevent
                        >
                          SFOGLIA / UPLOAD AREA
                        </label>
                        <input
                          type="file"
                          id="imgPrincipalAgg"
                          name="imgPrincipalAgg"
                          @change="onChangeImageAgg"
                        />
                      </div>
                    </div>
                    <div
                      class="row div-row-img-item"
                      style="
                        border-top: 4px dashed #ededed;
                        margin-top: 15px;
                        padding-top: 15px;
                      "
                    >
                      <div class="col-12">
                        <label
                          class="switch switch-pill switch-primary"
                          style="
                            margin: 2px;
                            margin-bottom: -2px;
                            vertical-align: bottom;
                          "
                        >
                          <input
                            type="checkbox"
                            class="switch-input"
                            id="idAssociationCodeImage"
                            :checked="checkAssociationCodeImage"
                            @change="onChangeAssociationCodeImage"
                          />
                          <span class="switch-slider" data-on data-off></span>
                        </label>
                        <label class="label-name" style="margin-bottom: 0px"
                          >Associazione automatica codice / nome file</label
                        >
                      </div>
                    </div>
                    <div class="row" style="margin-top: 15px">
                      <div class="col-12 text-right">
                        <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="confirmCancelNewCategories"
                        ><i class="fa fa-chevron-left"></i>
                          Indietro
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <!-- old modal img 
                  <div
                    class="modal fade bd-example-modal-lg"
                    id="modalImageExistFolder"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="myLargeModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-lg">
                      <div class="modal-content">
                        <div class="row">
                          <div
                            class="col-4 text-center"
                            v-for="arrayAllImagesExistFolders in arrayAllImagesExistFolder"
                            v-bind:key="arrayAllImagesExistFolders.id"
                            @click="
                              selectReplaceImageExist(
                                arrayAllImagesExistFolders.idImgAgg,
                                arrayAllImagesExistFolders.imgName
                              )
                            "
                          >
                            <div class="contPreviewImageExistFolder">
                              <img
                                :src="arrayAllImagesExistFolders.img"
                                class="previewImageExistFolder"
                              /><br />
                              <div class="div-row-img-item">
                                <label class="label-name">{{
                                  arrayAllImagesExistFolders.imgName
                                }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  old modal img -->
                  <!-- modal immagini -->
                  <div
                    class="modal"
                    id="modalImageExistFolder"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="myModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialo popup" role="document">
                      <div class="modal-content modal">
                        <div class="modal-header text-center">
                          

                          <div class="row" style="width:100%;">
                            <div class="col-4 text-left"> 
                              <h2 style="color:#303C53;font-weight:bold;text-transform:uppercase;">Gestione immagini</h2>
                            </div>
                            <div class="col-2 text-right">
                            <select class="form-control" id="month" name="month" @change="Search()">
                              <option value="">Mese</option>
                              <option value="01">Gennaio</option>
                              <option value="02">Febbraio</option>
                              <option value="03">Marzo</option>
                              <option value="04">Aprile</option>
                              <option value="05">Maggio</option>
                              <option value="06">Giugno</option>
                              <option value="07">Luglio</option>
                              <option value="08">Agosto</option>
                              <option value="09">Settembre</option>
                              <option value="10">Ottobre</option>
                              <option value="11">Novembre</option>
                              <option value="12">Dicembre</option>
                            </select>
                          </div>
                          <div class="col-2 text-right">
                            <select class="form-control" id="year" name="year" @change="Search()">
                              <option value="">Anno</option>
                              <option value="2025">2025</option>
                              <option value="2024">2024</option>
                              <option value="2023">2023</option>
                              <option value="2022">2022</option>
                              <option value="2021">2021</option>
                              <option value="2020">2020</option>
                              <option value="2019">2019</option>
                              <option value="2018">2018</option>
                              <option value="2017">2017</option>
                              <option value="2016">2016</option>
                              <option value="2015">2015</option>
                              <option value="2014">2014</option>
                              <option value="2013">2013</option>
                              <option value="2012">2012</option>
                              <option value="2011">2011</option>
                              <option value="2010">2010</option>
                            </select>
                          </div>
                            <div class="col-4"> 
                              <input type="text" class="form-control" id="search" required="required" name="search" placeholder="Cerca" @keyup="Search()"/> 
                            </div>
                          </div>

                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"

                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body mx-3">
                          <div class="md-form mb-5">
                            <div
                              class="row">
                              <ul class="list-group" id="ul-image" @scroll="handleScroll">
                              <li class="listLi" v-for="arrayAllImagesExistFolders in arrayAllImagesExistFolder" v-bind:key="arrayAllImagesExistFolders.id" @click="
                                selectReplaceImageExist(
                                idImageSelectedToReplaceImage,
                                arrayAllImagesExistFolders.imgName)" >
                                <div class="list-group-item" :style="'cursor:pointer;position: relative;min-width:110px;min-height:110px;min-width:110px;max-width:110px;background-size:cover;background-image:url(\'' + arrayAllImagesExistFolders.img + '\')'">
                                  <div v-if="arrayAllImagesExistFolders.ext!=''" class="div-extension-img">
                                    <label>{{ arrayAllImagesExistFolders.ext }}</label>
                                  </div>
                                  <label class="labelListImage">{{ arrayAllImagesExistFolders.imgName }}</label>
                                </div>
                                </li> 
                            </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end modal immagini -->

                  <!-- END TAB IMAGES -->

                  <!-- VENDITE -->
                  <div
                    class="card-body tab-pane"
                    id="DetailSale"
                    role="tabpanel"
                    style="padding-left: 25px; padding-right: 25px"
                  >
                    <div class="row">
                      <div class="col-8">
                        <div class="row">
                          <pageDetail
                            functions="adminCrmItemsPriceList"
                            :configurations="DetailSaleConfigurations"
                            :jsonValue="detailData"
                          ></pageDetail>
                        </div>
                      </div>
                      <div class="col-4">
                        <!-- <pageDetail
                          functions="adminCrmItemsPriceList"
                          :configurations="DetailPriceConfigurations"
                          :jsonValue="detailData"
                          style="padding: 0px"
                        ></pageDetail> -->
                        <div id="div-cont-img-agg"></div>

                        <div class="col-12 text-right">
                          <h3 style="    font-size: 20px;
    font-weight: lighter;
    color: rgb(48, 60, 84);">Aggiungi Listino</h3>
                          <i
                            class="fa fa-plus-circle"
                            style="font-size: 22px; cursor: pointer;"
                            id="add-img-agg"
                            @click="addPriceList"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 text-right">
                        <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="confirmCancelNewCategories"
                        >
                        <i class="fa fa-times"></i>&nbsp;
                          {{ cancel }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-success"
                          @click="confirmSaveNewCategories"
                        >
                        <i class="fa fa-floppy-o"></i>&nbsp;
                          {{ save }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- END VENDITE -->
                  <!-- COMMERCIALE -->
                  <div
                    class="card-body tab-pane"
                    id="DetailCommercial"
                    role="tabpanel"
                  >
                    <div class="row">
                      <pageDetail
                        functions="adminCrmItemsCommercial"
                        :configurations="DetailCommercialConfiguration"
                        :jsonValue="detailData"
                      ></pageDetail>
                    </div>
                    <div class="row">
                      <div class="col-12 text-right">
                        <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="confirmCancelNewCategories"
                        > <i class="fa fa-times"></i>&nbsp;

                          {{ cancel }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-success"
                          @click="confirmSaveNewCategories"
                        >  <i class="fa fa-floppy-o"></i>&nbsp;
                          {{ save }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- END COMMERCIALE -->
                  <!-- TRADUZIONI -->
                  <div
                    class="card-body tab-pane"
                    id="detailTranslations"
                    role="tabpanel"
                  >
                    <div class="col-10">
                      <div class="row" v-if="itemLanguages.length > 0">
                        <div class="col-2">
                          <b></b>
                        </div>
                        <div class="col-3">
                          <label>Lingua</label>
                        </div>
                        <div class="col-3">
                          <label>Descrizione</label>
                        </div>
                        <div class="col-4">
                          <label>Caratteristica</label>
                        </div>
                      </div>
                    </div>
                    <div
                      v-for="itemLanguage in itemLanguages"
                      v-bind:key="itemLanguage.id"
                    >
                      <div class="col-10">
                        <div class="row add div-row-translation">
                          <div class="col-2 text-left align-self-center">
                            <button
                              type="button"
                              class="btn btn-success"
                              @click="
                                executeOpenTranslationsLanguage(itemLanguage.id)
                              "
                            >
                              <i class="fa fa-pencil"></i>
                            </button>

                            <button
                              type="button"
                              class="btn btn-danger"
                              @click="
                                executeCancelTranslationsLanguage(
                                  itemLanguage.id
                                )
                              "
                            >
                              <i class="fa fa-trash" style="color: #fff"></i>
                            </button>
                          </div>
                          <div class="col-3 align-self-center">
                            <span
                              class="col- col-form-label nopadding"
                              :for="itemLanguage.language_id"
                              >{{ itemLanguage.language_id }}</span
                            >
                          </div>

                          <div class="col-3 align-self-center">
                            <div class="translate-characteristic">
                              <span
                                class="col- col-form-label nopadding"
                                :for="itemLanguage.description"
                                >{{ itemLanguage.description }}</span
                              >
                            </div>
                          </div>

                          <div class="col-4 align-self-center">
                            <div class="translate-characteristic">
                              <span
                                class="col- col-form-label nopadding"
                                :for="itemLanguage.meta_tag_characteristic"
                                >{{
                                  itemLanguage.meta_tag_characteristic
                                }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" >
                      <div class="col-12 text-right">
                        <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="confirmCancelNewCategories"
                        ><i class="fa fa-chevron-left"></i>
                          Indietro
                        </button>
                        <button
                          v-if="!noMoreTranslate"
                          type="button"
                          class="btn btn-primary button-add"
                          @click="confirmSaveNewTranslate()"
                        ><i class="fa fa-plus"></i> 
                          Aggiungi
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- END TRADUZIONI -->
                  <!-- CORRELATI -->
                  <div
                    class="card-body tab-pane"
                    id="detailCategories"
                    role="tabpanel"
                  >
                    <div class="col-8">
                      <div class="row">
                        <div class="col-3 align-self-center">
                          <label>Codice</label>
                          <input
                            type="internal_codesearc"
                            class="form-control"
                            id="internal_codesearc"
                            required="required"
                            name="internal_codesearc"
                          />
                        </div>
                        <div class="col-4 align-self-center">
                          <label>Descrizione</label>
                          <input
                            type="descriptionsearc"
                            class="form-control"
                            id="descriptionsearc"
                            required="required"
                            name="descriptionsearc"
                          />
                        </div>
                        <div class="col-3 align-self-center">
                          <label>Categoria</label>
                          <select2
                            class="form-control"
                            id="category_idsearc"
                            name="category_idsearc"
                            style="height: 56px;"
                            required="required"
                            service="category"
                          ></select2>
                        </div>
                        <div class="col-2 align-self-center">
                          <div class="col-12 text-right">
                            <label></label>
                            <button
                              type="button"
                              class="btn btn-primary"
                              @click="confirmSearchRelated"
                            >	<i class="fa fa-search"></i>
                              Cerca
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div
                      v-for="detailitemsList in tableDataRelated"
                      v-bind:key="detailitemsList.id"
                    >

                      <div class="col-8">
                        <div class="row div-row-related">
                          <div class="col-3 align-self-center">
                            <span
                              class="col- col-form-label nopadding"
                              :for="detailitemsList.internal_code"
                              >{{ detailitemsList.internal_code }}</span
                            >
                          </div>
                          <div class="col-4 align-self-center">
                            <span
                              class="col- col-form-label nopadding"
                              :for="detailitemsList.descriptionArticle"
                              >{{ detailitemsList.descriptionArticle }}</span
                            >
                          </div>
                          <div class="col-3 align-self-center">
                            <span
                              class="col- col-form-label nopadding"
                              :for="detailitemsList.descriptionCategories"
                              >{{ detailitemsList.descriptionCategories }}</span
                            >
                          </div>
                          <div class="col-2 align-self-center">
                            <div class="form-check">
                              <label
                                class="switch switch-pill switch-primary"
                                style="margin: 2px; vertical-align: bottom"
                              >
                                <input
                                  :id="'checkbox' + detailitemsList.id"
                                  :data-id-related="detailitemsList.id"
                                  :checked="detailitemsList.check_related"
                                  type="checkbox"
                                  name="check_related"
                                  class="switch-input checkboxRelated"
                                  @change="onChangeCheckRelated(detailitemsList.id)"
                                />
                                <div class="switch-slider"></div>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 text-right">
                        <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="confirmCancelNewCategories"
                        ><i class="fa fa-times"></i>&nbsp;
                          {{ cancel }}
                        </button>
                       <!-- <button
                          type="button"
                          class="btn btn-success buttonsave"
                          @click="confirmSaveNewRelated"
                        ><i class="fa fa-floppy-o"></i>&nbsp;
                          Salva
                        </button> --->
                      </div>
                    </div>
                  </div>
                  <!-- END CORRELATI -->

                  <!-- OPTIONAL -->
                  <div
                    class="card-body tab-pane"
                    id="DetailOptional"
                    role="tabpanel"
                  >
                    <div
                      class="row row-type-optional"
                      v-for="optional in arrayOptional"
                      v-bind:key="optional.id"
                    >
                      <div class="col-12">
                        <p>{{ optional.description }}</p>
                        <div
                          class="align-self-left"
                          style="display: inline-block"
                        >
                          <label
                            class="switch switch-pill switch-primary"
                            style="
                              margin: 2px;
                              margin-bottom: -2px;
                              vertical-align: bottom;
                            "
                          >
                            <input
                              type="checkbox"
                              class="switch-input"
                              :id="'switchTypeOptional' + optional.id"
                              :checked="optional.required"
                              @change="
                                onChangeSelectedTypeOptional(optional.id)
                              "
                            />
                            <span
                              class="switch-slider"
                              data-on
                              data-off
                            ></span> </label
                          >Obbligatorio
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="row row-single-optional" v-for="singleOptional in optional.optional[0]" v-bind:key="singleOptional.id" style="padding-left: 35px;margin-bottom: 15px;margin-top: 10px;">
                          <div class="col-12 div-row-optional" :data-id-optional="singleOptional.id">
                            <div class="row">
                              <div class="col-4 align-self-center">
                                <div class="align-self-left" style="display: inline-block">
                                  <label class="switch switch-pill switch-primary" style="margin: 2px;margin-bottom: -2px;vertical-align: bottom;">
                                    <input type="checkbox" class="switch-input" :id="'switchOptional' + singleOptional.id" :checked="singleOptional.selected" @change="onChangeSelectedOptional(singleOptional.id)"/>
                                    <span class="switch-slider" data-on data-off></span>
                                  </label>
                                </div>
                                <span class="option-description">{{singleOptional.description}}</span>
                              </div>
                              <div class="col-8 align-self-center">
                                <div class="cont-type" :id="'optionList' + singleOptional.id" style="display: inline-block" v-show="singleOptional">
                                  <label class="label-option">Variazione<br />
                                    <input class="form-control input-optional" :id="'variation' + singleOptional.id" :value="singleOptional.variationPrice"/>
                                  </label>

                                  <label v-if="singleOptional.variationType == '€'" style="display: inline" >
                                    <input type="radio" checked="checked" :name="'radio' + singleOptional.id" style="margin: 5px" value="€" />
                                    <span class="checkmark"></span>&nbsp;€
                                  </label>
                                  <label style="display: inline" v-else>
                                    <input type="radio" :name="'radio' + singleOptional.id" style="margin: 5px" value="€" />
                                    <span class="checkmark"></span>&nbsp;€
                                  </label>

                                  <label style="display: inline;padding: 0px;margin-right: 20px;" v-if="singleOptional.variationType == '%'">
                                    <input type="radio" checked="checked" :name="'radio' + singleOptional.id" style="margin: 5px" value="%"/>
                                    <span class="checkmark"></span>&nbsp;%
                                  </label>
                                  <label style="display: inline;padding: 0px;margin-right: 20px;" v-else>
                                    <input type="radio" :name="'radio' + singleOptional.id" style="margin: 5px" value="%"/>
                                    <span class="checkmark"></span>&nbsp;%
                                  </label>

                                  <label class="label-option">Disp.<br />
                                    <input class="form-control input-optional" :id="'availability' + singleOptional.id" :value="singleOptional.availability"/>
                                  </label>
                                  <label class="label-option" v-if="singleOptional.checkItemSupport">Ogni<br />
                                  <input class="form-control input-optional" :id="'supportVariationValue' + singleOptional.id" :value="singleOptional.supportVariationValue "/>
                                 
                                  </label>
                                  <label class="label-option" v-if="singleOptional.checkItemSupport">Um<br />
                                     <select :id="'umSupportVariationId' + singleOptional.id" :ref="'umSupportVariationId' + singleOptional.id" class="form-control umSupportItem nopadding" style="width:100%;min-width:100%"></select>
                                  </label>
                                  <label class="label-option" v-if="singleOptional.checkItemSupport">Di<br />
                                    <select class="form-control input-optional" :id="'supportParameter' + singleOptional.id" :value="singleOptional.supportParameter">
                                      <option value="Lunghezza">Lunghezza</option>
                                      <option value="Altezza">Altezza</option>
                                      <option value="Profondita">Profondità</option>
                                      <option value="Area">Area</option>
                                    </select>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 columns">
                        <div class="row">
                          <div class="col-12 text-right">
                            <button
                              type="button"
                              class="btn btn-danger"
                              data-dismiss="modal"
                              @click="confirmCancelNewCategories"
                            ><i class="fa fa-times"></i>&nbsp;
                              {{ cancel }}
                            </button>
                            <button
                              type="button"
                              class="btn btn-success"
                              @click="confirmSaveOptional"
                            ><i class="fa fa-floppy-o"></i>&nbsp;
                              {{ save }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- END OPTIONAL -->

                  <!-- modal immagini -->
                  <div
                    class="modal"
                    id="modalImgForm"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="myModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header text-center">
                          <h4 class="modal-title w-100 font-weight-bold">
                            Immagini
                          </h4>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body mx-3" style="cursor: pointer;">
                          <div class="md-form mb-5" style="cursor: pointer;">
                            <div
                              class="row" style="cursor: pointer;"
                              v-for="resultFilePopup in resultFilePopups"
                              v-bind:key="resultFilePopup.id"
                              @click="
                                UpdateImg(
                                  resultFilePopup.idImgAgg,
                                  resultFilePopup.imgName
                                )
                              "
                            >
                              <div class="col-4"  style="cursor: pointer;">
                                <img :src="resultFilePopup.img" />
                              </div>
                              <div class="col-8" style="cursor: pointer;">
                                <label>{{ resultFilePopup.imgName }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end modal immagini -->
                  <!--Modal esegui modifica traduzioni DetailTranslation-->
                  <div
                    class="modal"
                    id="modalExecuteTranslateItem"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="myModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-lg" role="document">
                      <div class="modal-content padding">
                        <div class="modal-header text-center">
                          <h4 class="modal-title w-100 font-weight-bold">
                            Modifica Traduzione Articolo
                          </h4>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body mx-12">
                          <div class="md-form mb-12">
                            <div class="row">
                              <div class="col-12">
                                <div
                                  class="col-12 text-right"
                                  style="padding-top: 1rem"
                                >
                                  <button
                                    type="button"
                                    class="btn btn-primary"
                                    @click="
                                      executeCopyDefaultTranslate(
                                        resultTranslatePopups.id,
                                        resultTranslatePopups.idItem,
                                        resultTranslatePopups.language_id
                                      )
                                    "
                                  ><i class="fa fa-clone"></i>
                                    COPIA DA LINGUA DI DEFAULT
                                  </button>
                                </div>
                                <pageDetail
                                  functions="adminCrmItemsTranslation"
                                  :configurations="
                                    DetailTranslationConfiguration
                                  "
                                  :jsonValue="resultTranslatePopups"
                                ></pageDetail>
                                <div
                                  class="col-12 text-right"
                                  style="padding-top: 3rem"
                                >
                                  <button
                                    type="button"
                                    class="btn btn-success"
                                    @click="
                                      confirmSaveTranslate(
                                        resultTranslatePopups.id,
                                        resultTranslatePopups.idItem,
                                        resultTranslatePopups.language_id,
                                        resultTranslatePopups.description,
                                        resultTranslatePopups.link,
                                        resultTranslatePopups.meta_tag_characteristic
                                      )
                                    "
                                  ><i class="fa fa-floppy-o"></i>&nbsp;
                                    SALVA
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end modal traduzioni -->
                  <!-- END TAB DETAIL -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
import TreeCategories from "@/components/TreeCategories.vue";
import Select2 from "@/components/Select2.vue";

export default {
  name: "adminCrmItems",
  components: {
    BootstrapTable,
    Select2,
    PageDetail,
    TreeCategories,
  },

  data: function () {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      language: dictionaryHelpers.getDictionary("Language"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      crm: dictionaryHelpers.getDictionary("CRM"),
      Items: dictionaryHelpers.getDictionary("Items"),
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      detailConfiguration: [],
      DetailAttributeConfiguration: [],
      DetailSaleConfigurations: [],
      DetailCommercialConfiguration: [],
      DetailPriceConfigurations: [],
      DetailTranslationConfiguration: [],
      DetailOptionsConfiguration: [],
      DetailDateConfiguration: [],
      price: [],
      resultFilePopups: [],
      itemLanguages: [],
      files: [],
      color: "#444444",
      white: [],
      detailOptionsData: {},
      detailData: {},
      resultTranslatePopups: {},
      detailDataRelatedItem: {},
      detailAttributeData: {},
      detailCommercialData: {},
      cont: 0,
      languages: 0,
      disableButton: true,
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      newCategories: dictionaryHelpers.getDictionary("newCategories"),
      newTitleArticoli: dictionaryHelpers.getDictionary("newTitleArticoli"),
      openDetail: dictionaryHelpers.getDictionary("OpenDetail"),
      save: dictionaryHelpers.getDictionary("Save"),
      defaultLanguageOptions: [],
      pageValueSelected: {
        length: 0,
        id: 0,
        languagePageSetting: { content: null },
      },
      tableConfiguration: [],
      tableCustomerResult: [],
      tableGroupDisabledConfiguration: [],
      detailEnabledConfiguration: [],
      tableGroupDisabledData: [],
      tableData: [],
      tableDataRelated: [],
      tableResult: [],
      titleDetail: null,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname,
      rowIdSelected: 0,
      rowsSelected: 0,
      selectedChangePrincipalImage: false,
      arrayOptional: [],
      listTreeCategories: [],
      arrayListCategoriesDetail: [],
      itemImages: [],
      arrayAllImagesExistFolder: [],
      checkAssociationCodeImage: false,
      checkOnlineItem: true,
      scriptGallery:false,
      noMoreTranslate: false,
      checkSupportItem: false,
      supports: [],
      pageImage: 1,
      idImageSelectedToReplaceImage: 0
    };
  },

  computed: {
    uploadDisabled() {
      return this.files.length === 0;
    },
  },

  mounted() {
    this.tableGroupDisabledConfiguration = [
      { inputType: "TableCheckbox", visibleOnTable: true },
      {
        field: "codeitemrelated",
        title: "Codice Articolo Correlato",
        visibleOnTable: true,
      },
    ];

    this.detailEnabledConfiguration = [
      {
        attribute: "",
        class: null,
        colspan: null,
        defaultValue: null,
        field: "related_item_id",
        filterType: "Input",
        inputType: "Select",
        label: "Articolo correlato",
        posX: 10,
        posY: 10,
        service: "relatedItem",
        title: "Articolo correlato",
      },
    ];
  },
  created() {
    
    var adminCrmItems = this;
   // spinnerHelpers.show();

    this.languages = storageData.sIdLanguage();

    adminCrmItems.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage(),
    };

    adminConfigurationServices.getFunctionality(function (result) {
      //0,1,2,4,3,5
      //0,0,1,4,3,5

      adminCrmItems.tableConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
      adminCrmItems.DetailDateConfiguration = result.data.tabsConfigurations[0].pageConfigurations; 
      adminCrmItems.DetailSaleConfigurations = result.data.tabsConfigurations[1].pageConfigurations;
      adminCrmItems.DetailAttributeConfiguration = result.data.tabsConfigurations[4].pageConfigurations;
    //  adminCrmItems.DetailPriceConfigurations = result.data.tabsConfigurations[3].pageConfigurations;
      adminCrmItems.DetailTranslationConfiguration = result.data.tabsConfigurations[5].pageConfigurations;
      adminCrmItems.loadTable();
    });
  },

  methods: {
    handleScroll(){
      if($('#ul-image').scrollTop() + $('#ul-image').innerHeight() >= $('#ul-image')[0].scrollHeight) {
        this.pageImage = this.pageImage + 1;
        this.selectImageExist(this.idImageSelectedToReplaceImage, this.selectedChangePrincipalImage);
      }
    },
    loadTable(ln) {
      spinnerHelpers.show();
      var adminCrmItems = this;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      } else {
        ln = this.languages;
      }
      itemServices.getAll(ln, function (result) {
        adminCrmItems.tableData = result.data;
        var url = new URL(window.location.href);
        var c = url.searchParams.get("id");
        if(c != '' && c != undefined && c != null){
          adminCrmItems.executeOpenDetail(c);
        }
        
        //spinnerHelpers.hide();
      });
    },

    handleFileDrop(e) {
      let files = e.target.files;
      if (!files) return;
      [...files].forEach((f) => {
        this.files.push(f);
      });
      this.color = "#444444";
    },
    handleFileInput(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      for (var i = 0; i < files.length; i++) {
        this.createAttachmentAgg(e.target.id, files[i].name, files[i]);
      }
    },
    createAttachmentAgg(id, name, file) {
      var adminCrmItems = this;
      var jsonImgAggUpload = this;
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        var jsonAttachment = {};
        jsonAttachment["id"] = adminCrmItems.cont + 1;
        adminCrmItems.cont = adminCrmItems.cont + 1;
        jsonAttachment["name"] = name;
        jsonAttachment["size"] = "0";
        jsonAttachment["base64"] = e.target.result;
        adminCrmItems.files.push(jsonAttachment);
        adminCrmItems.executeSaveNewfile();
      };
      reader.readAsDataURL(file);
    },

    executeSaveNewfile() {
      var adminCrmItems = this;
        var data = {
        imgAgg:adminCrmItems.files,
        idItem: adminCrmItems.rowIdSelected, 

      };
      itemServices.updateImageAggFile(data, function (result) {
          notificationHelpers.success("Immagine aggiunta correttamente");
          adminCrmItems.onTabAdminItemsAttribute();
      });
    },

    removeFile(fileKey) {
      this.files.splice(fileKey, 1);
    },
    fileDragIn() {
      this.color = "white";
    },
    fileDragOut() {
      this.color = "#444444";
    },

    languageChange(value) {
      spinnerHelpers.show();
      var adminCrmItems = this;
      this.languages = value;
      adminCrmItems.loadTable(value);
      spinnerHelpers.hide();
    },

    CheckOnlineFormatter(value, row, index, field){
      if(row.online){
      var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" checked="checked" onclick="adminCrmItems.__vue__.onChangeCheckOnlineItemList(' + row.id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
      }else{
        var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" onclick="adminCrmItems.__vue__.onChangeCheckOnlineItemList(' + row.id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
      }
      return newList;
    },

    CheckAnnouncementsFormatter(value, row, index, field){
      if(row.announcements){
        var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" checked="checked" onclick="adminCrmItems.__vue__.onChangeCheckAnnouncementsItemList(' + row.id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
      }else{
        var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" onclick="adminCrmItems.__vue__.onChangeCheckAnnouncementsItemList(' + row.id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
      }
      return newList;
    },

    CheckPromotionFormatter(value, row, index, field){
      if(row.promotion){
      var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" checked="checked" onclick="adminCrmItems.__vue__.onChangeCheckPromotionItemList(' + row.id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
      }else{
        var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" onclick="adminCrmItems.__vue__.onChangeCheckPromotionItemList(' + row.id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
      }
      return newList;
    },


    ItemsFormatter(value, row, index, field) {
      var adminCrmItems = this;
      var html =
        '<div class="container-fluid nopadding" style="min-width:80px;"><div class="row">';
      html +=
        '<button class="btn btn-success" onclick="adminCrmItems.__vue__.executeOpenDetail(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
      html +=
        '<button class="btn btn-primary" onclick="adminCrmItems.__vue__.clone(' +
        row.id +
        ')"><i class="fa fa-files-o"/></button>';
      html +=
        '<button class="btn btn-danger" onclick="adminCrmItems.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';

      if (functionHelpers.isValued(this.tableResult)) {
        $.each(this.tableResult, function (i, result) {
          if (result.id == row.id) {
            if (result.success) {
              html +=
                '<div class="col-1"><i class="fa fa-check text-success" title="';
              if (functionHelpers.isValued(result.message)) {
                html += result.message;
              } else {
                html += adminCrmItems.updateCompleted;
              }
              html += '" /></div>';
            } else {
              html +=
                '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                result.message +
                '" /></div>';
            }
            return;
          }
        });
      }
      html += "</div>";
      return html;
    },

changeTitleItems() {
    var adminCrmItems = this;
    var SeotitleToTitles= $("#meta_tag_title").val();
    
   if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
        var d = ((96 * 10)/100) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
  }else{
   if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
        var d = ((96 * SeotitleToTitles.length)/30) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
      }
     if (SeotitleToTitles.length >= 31 && SeotitleToTitles.length <= 60){
        var d = ((96 * SeotitleToTitles.length)/60) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
      }
      if (SeotitleToTitles.length >= 61 && SeotitleToTitles.length <= 1000){
        var d = ((96 * SeotitleToTitles.length)/1000) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
      }
    }
 },


 onKeyUpTitleItems() {
    var adminCrmItems = this;
    var SeotitleToTitles= $("#meta_tag_title").val();
    
   if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
        var d = ((96 * 10)/100) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
  }else{
   if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
        var d = ((96 * SeotitleToTitles.length)/30) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
      }
     if (SeotitleToTitles.length >= 31 && SeotitleToTitles.length <= 60){
        var d = ((96 * SeotitleToTitles.length)/60) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
      }
      if (SeotitleToTitles.length >= 61 && SeotitleToTitles.length <= 1000){
        var d = ((96 * SeotitleToTitles.length)/1000) + "%";
        $('#meta_tag_title_feedback').remove();
        $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
      }
    }
 },

    onKeyUpDescriptionItems() {
    var adminCrmItems = this;
    var SeoDesciptionToTitles= $("#meta_tag_description").val();

    if (SeoDesciptionToTitles == '' || SeoDesciptionToTitles == null || SeoDesciptionToTitles == 'null' || SeoDesciptionToTitles == 0) {
      var d = ((96 * 10)/100) + "%";
          $('#meta_tag_description_feedback').remove();
          $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(4.7%); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
  }else{
    if (SeoDesciptionToTitles.length >= 0 && SeoDesciptionToTitles.length <= 70){
            var d = ((96 * SeoDesciptionToTitles.length)/70) + "%";
              $('#meta_tag_description_feedback').remove();
              $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
        }

        if (SeoDesciptionToTitles.length >= 71 && SeoDesciptionToTitles.length <= 155){
            var d = ((96 * SeoDesciptionToTitles.length)/155) + "%";
            $('#meta_tag_description_feedback').remove();
            $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -105px;left: 13px;"></div>')
        }

        if (SeoDesciptionToTitles.length >= 156 && SeoDesciptionToTitles.length <= 2000){
            var d = ((96 * SeoDesciptionToTitles.length)/2000) + "%";
            $('#meta_tag_description_feedback').remove();
            $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -105px;left: 13px;"></div>')
        }
      }
  },

  changeDescriptionItems() {
    var adminCrmItems = this;
    var SeoDesciptionToTitles= $("#meta_tag_description").val();

 if (SeoDesciptionToTitles == '' || SeoDesciptionToTitles == null || SeoDesciptionToTitles == 'null' || SeoDesciptionToTitles == 0) {
      var d = ((96 * 10)/100) + "%";
          $('#meta_tag_description_feedback').remove();
          $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(4.7%); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
  }else{
    if (SeoDesciptionToTitles.length >= 0 && SeoDesciptionToTitles.length <= 70){
            var d = ((96 * SeoDesciptionToTitles.length)/70) + "%";
              $('#meta_tag_description_feedback').remove();
              $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
        }

        if (SeoDesciptionToTitles.length >= 71 && SeoDesciptionToTitles.length <= 155){
            var d = ((96 * SeoDesciptionToTitles.length)/155) + "%";
            $('#meta_tag_description_feedback').remove();
            $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -105px;left: 13px;"></div>')
        }

        if (SeoDesciptionToTitles.length >= 156 && SeoDesciptionToTitles.length <= 2000){
            var d = ((96 * SeoDesciptionToTitles.length)/2000) + "%";
            $('#meta_tag_description_feedback').remove();
            $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -105px;left: 13px;"></div>')
        }
      }
  },

    addPriceList() {
      var adminCrmItems = this;

      //var cont = 0;
      var html = "";
      if (adminCrmItems.cont < 50) {
        adminCrmItems.cont = adminCrmItems.cont + 1;
        html +=
          '<div class="row" style="margin-bottom: 10px;" data-id-row="' +
          adminCrmItems.cont +
          '" id="divcont-' +
          adminCrmItems.cont +
          '" >';
        html += '<div class="col-8">';
        html +=
          '<select class="custom-select pricelist_id" style="width:100%!important;" id="pricelist_id' +
          adminCrmItems.cont +
          '" name="pricelist_id' +
          adminCrmItems.cont +
          '"></select>';
        html += "</div>";
        html += '<div class="col-4">';
        html +=
          '<input type="text" style="min-height: 56px" class="form-control pricelist" id="pricelist' +
          adminCrmItems.cont +
          '" name="pricelist' +
          adminCrmItems.cont +
          '">';
        html += "</div>";
        html += "</div>";
        $("#div-cont-img-agg").append(html);
      }
      $.getScript(
        "https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js"
      ).done(function () {
        var searchParam = "";
        $("#pricelist_id" + adminCrmItems.cont).select2({
          ajax: {
            url: configData.wsRootServicesUrl + "/api/v1/list/select",
            data: function (params) {
              if (params.term == "") {
                searchParam = "*";
              } else {
                searchParam = params.term;
              }
              var query = {
                search: searchParam,
              };
              return query;
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data);
              return {
                results: dataParse.data,
              };
            },
          },
        });
      });
    },

    getImage(id) {
      var adminCrmItems = this;
      if (functionHelpers.isValued(id)) {
        itemServices.getByFile(id, function (result) {
          adminCrmItems.resultFilePopups = result.data;
          $("#modalImgForm").modal("show");
        });
      } else {
        itemServices.getByFileNoId(function (result) {
          adminCrmItems.resultFilePopups = result.data;
          $("#modalImgForm").modal("show");
        });
      }
    },

    UpdateImg(id, img) {
      var adminCrmItems = this;
      var data = {
        idItem: adminCrmItems.rowIdSelected,
        idImgAgg: id,
        imgName: img,
        imgBase64: "",
      };
      itemServices.updateImages(data, function (result) {
        if (functionHelpers.isValued(id)) {
          notificationHelpers.success("Immagine modificata correttamente");
          $("#modalImgForm").modal("hide");
          adminCrmItems.onTabAdminItemsAttribute();
        } else {
          notificationHelpers.success("Immagine salvata correttamente");
          $("#modalImgForm").modal("hide");
          adminCrmItems.onTabAdminItemsAttribute();
        }
      });
    },

    /* IMG AGG */
    addImg() {
      var adminCrmItems = this;
      var jsonFiles = {};
      var imgAggFiles = [];

      jsonFiles["id"] = adminCrmItems.cont + 1;
      adminCrmItems.cont = adminCrmItems.cont + 1;
      jsonFiles["name"] = "";
      jsonFiles["size"] = "0";
      jsonFiles["base64"] = "";
      adminCrmItems.files.push(jsonFiles);
      /* END IMG AGG */
    },

    confirmSearchRelated(id) {
      spinnerHelpers.show();
      var adminCrmItems = this;
      var ln = adminCrmItems.languages;
      // this.rowIdSelected = id;

      this.titleDetail = this.customer;
      adminCrmItems.detailData.meta_tag_characteristic = "";

      var arraySearchParam = [];
      var jsonSearchParam = {};
      var data = {};
      jsonSearchParam["internal_codesearc"] = $("#internal_codesearc").val();
      jsonSearchParam["descriptionsearc"] = $("#descriptionsearc").val();
      jsonSearchParam["category_idsearc"] = $("#category_idsearc").val();
      arraySearchParam.push(jsonSearchParam);

      data.search = arraySearchParam;
      data.idLanguage = ln;
      data.itemId = adminCrmItems.rowIdSelected;
      itemServices.getAllRelatedSearch(data, function (result) {
        //adminCrmItems.rowIdSelected,
        //ln,
        adminCrmItems.tableDataRelated = result.data;
        spinnerHelpers.hide();
      });
    },

    Search() { 
      var adminSettingNews = this;
      adminCrmItems.pageImage = 1;
      adminSettingNews.selectImageExist(adminCrmItems.idImageSelectedToReplaceImage, adminCrmItems.selectedChangePrincipalImage);
    },

    executeOpenTranslationsLanguage(id) {
      var adminCrmItems = this;
      itemServices.getByTranslate(id, function (result) {
        adminCrmItems.resultTranslatePopups = result.data[0];
        $("#modalExecuteTranslateItem").modal("show");
      });

    },
    executeCancelTranslationsLanguage(id) {
      var adminCrmItems = this;
      if (confirm("Sei sicuro di voler eliminare la traduzione?"))
        itemServices.getCancelTranslate(id, function (result) {
          notificationHelpers.success("Eliminazione avvenuta correttamente");
          adminCrmItems.loadTranslation();
        });
    },

    executeCopyDefaultTranslate(id, idItem, language_id) {
      var adminCrmItems = this;

      //se modifico riga esistente
      if (id != "") {
        itemServices.getByTranslateDefault(id, idItem, language_id, function (
          result
        ) {
          adminCrmItems.resultTranslatePopups = result.data[0];
        });
      } else {
        //se modifico riga aggiungi nuova traduzione
        itemServices.getByTranslateDefaultNew(idItem, language_id, function (
          result
        ) {
          adminCrmItems.resultTranslatePopups = result.data[0];
        });
      }
    },
    changeDescription(field, value) {
      var adminCrmItems = this;

      var titleToUrl = $("#detailItem #description").val(),
        cleanUrl = "";
      cleanUrl =
        "/" +
        titleToUrl
          .replace(/([,\!\^\$\.\*\÷\±\¿\¶\~\«\¢\ß\¥\™\©\®\+\?\|\<\>\-\&\€\%\=\"\'\£\#\;\:\§\@\°\s])/g, "-")    
          .replace(/([\à\s])/g, "a")
          .replace(/([\á\s])/g, "a")
          .replace(/([\è\s])/g, "e")
          .replace(/([\ê\s])/g, "e")
          .replace(/([\é\s])/g, "e")
          .replace(/([\ì\s])/g, "i")
          .replace(/([\í\s])/g, "i")
          .replace(/([\ò\s])/g, "o")
          .replace(/([\ó\s])/g, "o")
          .replace(/([\ù\s])/g, "u")
          .replace(/([\ú\s])/g, "u")
          .replace(/([\ż\s])/g, "z")
          .replace(/([\ź\s])/g, "z")
         	.replace(/([\ź\s])/g, "n")
          .replace(/([\ń\s])/g, "n")
          .replace(/([\ņ\s])/g, "n")
          .replace(/([\ņ\s])/g, "n")  
          .toLowerCase();

      for (var i=0; i<100; i++){
        if (cleanUrl.includes('--')) { 
          cleanUrl = cleanUrl.replace('--', '-');
        }else{
          break;
        } 
      }

      $("#meta_tag_link").val(cleanUrl);
      adminCrmItems.detailData.link = dataHelpers.unbind(cleanUrl);
      adminCrmItems.detailData.meta_tag_link = dataHelpers.unbind(cleanUrl);
      //this.checkUrl(cleanUrl);
    },


    changeTitle(field, value) {
      var adminCrmItems = this;

      var titleToUrl = $("#modalExecuteTranslateItem #description").val(),
        cleanUrl = "";
      cleanUrl =
        "/" +
        titleToUrl
          .replace(/([,\!\^\$\.\*\÷\±\¿\¶\~\«\¢\ß\¥\™\©\®\+\?\|\<\>\-\&\€\%\=\"\'\£\#\;\:\§\@\°\s])/g, "-")    
          .replace(/([\à\s])/g, "a")
          .replace(/([\á\s])/g, "a")
          .replace(/([\è\s])/g, "e")
          .replace(/([\ê\s])/g, "e")
          .replace(/([\é\s])/g, "e")
          .replace(/([\ì\s])/g, "i")
          .replace(/([\í\s])/g, "i")
          .replace(/([\ò\s])/g, "o")
          .replace(/([\ó\s])/g, "o")
          .replace(/([\ù\s])/g, "u")
          .replace(/([\ú\s])/g, "u")
          .replace(/([\ż\s])/g, "z")
          .replace(/([\ź\s])/g, "z")
         	.replace(/([\ź\s])/g, "n")
          .replace(/([\ń\s])/g, "n")
          .replace(/([\ņ\s])/g, "n")
          .replace(/([\ņ\s])/g, "n")  
          .toLowerCase();

      for (var i=0; i<100; i++){
        if (cleanUrl.includes('--')) { 
          cleanUrl = cleanUrl.replace('--', '-');
        }else{
          break;
        } 
      }

      $("#modalExecuteTranslateItem #link").val(cleanUrl);
      adminCrmItems.resultTranslatePopups.link = dataHelpers.unbind(cleanUrl);
      // this.checkUrl(cleanUrl);
    },
    checkUrl(url) {
      pageServices.checkExistUrl(url, function (result) {
        if (result.data) {
          validationHelpers.setDetailError(
            "link",
            dictionaryHelpers.getDictionary("UrlAlreadyExist")
          );
        } else {
          $("#modalExecuteTranslateItem #link").removeClass("error");
          validationHelpers.clear("#modalExecuteTranslateItem");
        }
      });
    },
    executeOpenDetail(id) {
      spinnerHelpers.show();
      var adminCrmItems = this;
      var ln = adminCrmItems.languages;
      this.rowIdSelected = id;
      this.titleDetail = this.customer;
      adminCrmItems.detailData.meta_tag_characteristic = "";
      $.each(this.tableData, function (i, row) {
        if (adminCrmItems.rowIdSelected == row.id) {
          adminCrmItems.supports = row.supports;
          adminCrmItems.checkAssociationCodeImage = row.image_code_association;
          adminCrmItems.detailData = row;
          adminCrmItems.checkOnlineItem = adminCrmItems.detailData.online;

        var SeotitleToTitles = row.meta_tag_title;
        if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
              var d = ((96 * 10)/100) + "%";
              $('#meta_tag_title_feedback').remove();
              $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
        }else{
        if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
              var d = ((96 * SeotitleToTitles.length)/30) + "%";
              $('#meta_tag_title_feedback').remove();
              $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
            }
          if (SeotitleToTitles.length >= 31 && SeotitleToTitles.length <= 60){
              var d = ((96 * SeotitleToTitles.length)/60) + "%";
              $('#meta_tag_title_feedback').remove();
              $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
            }
            if (SeotitleToTitles.length >= 61 && SeotitleToTitles.length <= 1000){
              var d = ((96 * SeotitleToTitles.length)/1000) + "%";
              $('#meta_tag_title_feedback').remove();
              $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
            }
          } 
          
      var SeoDesciptionToTitles = row.meta_tag_description;
      if (SeoDesciptionToTitles == '' || SeoDesciptionToTitles == null || SeoDesciptionToTitles == 'null' || SeoDesciptionToTitles == 0) {
            var d = ((96 * 10)/100) + "%";
                $('#meta_tag_description_feedback').remove();
                $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(4.7%); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
        }else{
          if (SeoDesciptionToTitles.length >= 0 && SeoDesciptionToTitles.length <= 70){
                  var d = ((96 * SeoDesciptionToTitles.length)/70) + "%";
                    $('#meta_tag_description_feedback').remove();
                    $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
              }

              if (SeoDesciptionToTitles.length >= 71 && SeoDesciptionToTitles.length <= 155){
                  var d = ((96 * SeoDesciptionToTitles.length)/155) + "%";
                  $('#meta_tag_description_feedback').remove();
                  $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -105px;left: 13px;"></div>')
              }

              if (SeoDesciptionToTitles.length >= 156 && SeoDesciptionToTitles.length <= 2000){
                  var d = ((96 * SeoDesciptionToTitles.length)/2000) + "%";
                  $('#meta_tag_description_feedback').remove();
                  $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -105px;left: 13px;"></div>')
              }
            }
        }
      });

      itemServices.getAllRelated(adminCrmItems.rowIdSelected, ln, function (
        result) {
        adminCrmItems.tableDataRelated = result.data;
        spinnerHelpers.hide();
      });

      $("#tabTable").removeClass("active");
      $("#detailItem").addClass("active");
      $("#tabDetail").addClass("active");
      $("#detailItemsList").removeClass("active");
      $("#detailCategories").removeClass("active");
      $("#detailItemRelated").removeClass("active");
      $("#DetailAttribute").removeClass("active");
      $("#DetailCommercial").removeClass("active");
      $("#DetailOptions").removeClass("active");
      $("#DetailSale").removeClass("active");
      $("#detailTranslations").removeClass("active");
      $("#DetailOptional").removeClass("active");
      $("#DetailListCategories").removeClass("active");
      $("#DetailImages").removeClass("active");
      spinnerHelpers.hide();
    },

    clone(id) {
      var adminCrmItems = this;
      var ln = adminCrmItems.languages;
      spinnerHelpers.show();
      itemServices.clone(id, function () {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("CloneCompleted")
        );

        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminCrmItems.loadTable(ln);
      });
    },

       delete(id) {
       if (confirm("Sei sicuro di voler eliminare?")) {
        this.executeDelete(id);
      }
    },

    executeDelete(id) {
      var adminCrmItems = this;
      var ln = adminCrmItems.languages;
      spinnerHelpers.show();
      itemServices.del(id, function () {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("DeleteCompleted")
        );

        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminCrmItems.loadTable(ln);
        window.scrollTo(0, 0);
      });
    },

    RemoveFileDb(id, fileKey) {
      var adminCrmItems = this;
       if (confirm("Sei sicuro di voler eliminare l'immagine?")) {
      itemServices.RemoveFileDb(id, function (result) {
        adminCrmItems.onTabAdminItemsAttribute();
        notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
        });  
      }       
    },

    removeFile(id, fileKey) {
      var adminCrmItems = this;
       if (confirm("Sei sicuro di voler eliminare l'immagine?")) {
      itemServices.removeFile(id, function (result) {
        adminCrmItems.onTabAdminItemsAttribute();  
        notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));  
      });  
    }
    },

    onNewCategories() {
      spinnerHelpers.show();
      this.detailData = {};
      this.titleDetail = this.newCategories;
      this.rowIdSelected = 0;

      $('#meta_tag_title_feedback').remove();
      $('#meta_tag_description_feedback').remove();
       //$('#meta_tag_keyword_feedback').remove();

      $('#meta_tag_title').before('<div id="meta_tag_title_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
      $('#meta_tag_description').after('<div id="meta_tag_description_feedback" style="width: calc(4.7%); height: 5px;background: #FF0000;position: relative;bottom: -105px;left: 13px;"></div>')
     // $('#meta_tag_keyword').before('<div id="meta_tag_keyword_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')

      $("#tabDetail").addClass("active");
      $("#tabTable").removeClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveTranslate(
      id,
      idItem,
      language_id,
      description,
      link,
      meta_tag_characteristic
    ) {
      if (functionHelpers.isValued(id)) {
        //spinnerHelpers.show();
        var adminCrmItems = this;
        var data = {};
        var data = {
          id: id,
          idItem: idItem,
          language_id: language_id,
          description: description,
          link: link,
          meta_tag_characteristic: meta_tag_characteristic,
        };
        itemServices.updateTranslate(data, function (result) {
          notificationHelpers.success("Immagine modificata correttamente");
          $("#modalExecuteTranslateItem").modal("hide");
          adminCrmItems.loadTranslation();
        });
      } else {
        var adminCrmItems = this;
        var data = {};
        var data = {
          idItem: adminCrmItems.rowIdSelected,
          language_id: language_id,
          description: description,
          link: link,
          meta_tag_characteristic: meta_tag_characteristic,
        };
        itemServices.insertTranslate(data, function (result) {
          notificationHelpers.success("Immagine aggiunta con successo");
          $("#modalExecuteTranslateItem").modal("hide");
          adminCrmItems.loadTranslation();
        });
      }
    },

    confirmSaveNewTranslate() {
      $("#modalExecuteTranslateItem").modal("show");
      var adminCrmItems = this;
      var ln = adminCrmItems.languages;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }
      adminCrmItems.resultTranslatePopups.id = "";
      adminCrmItems.resultTranslatePopups.idItem = adminCrmItems.rowIdSelected;
      adminCrmItems.resultTranslatePopups.language_id = ln;
      adminCrmItems.resultTranslatePopups.description = "";
      adminCrmItems.resultTranslatePopups.link = "";
      adminCrmItems.resultTranslatePopups.meta_tag_characteristic = "";
      var searchParam = "";
      $("#language_id").select2({
        ajax: {
          url: configData.wsRootServicesUrl + "/api/v1/language/selectlanguagesitemstranslate",
          data: function (params) {
            if (params.term == "") {
              searchParam = "*";
            } else {
              searchParam = params.term;
            }
            var query = {
              search: searchParam,
              idItem: adminCrmItems.rowIdSelected
            };
            return query;
          },
          processResults: function (data) {
            var dataParse = JSON.parse(data);
            return {
              results: dataParse.data,
            };
          },
        },
      });

    },

 /*   confirmSaveNewRelated() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveRelatedSave();
      }
    },

    executeSaveRelatedSave() {
      spinnerHelpers.show();
      var adminCrmItems = this;
      var arrayRelated = [];
      var data = {};
      var ln = "";
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }
      $(".checkboxRelated").each(function (index) {
        if ($(this).is(":checked")) {
          var jsonRelated = {};
          jsonRelated["item_id_related"] = $(this).attr("data-id-related");
          console.log(jsonRelated);
          arrayRelated.push(jsonRelated);
           console.log(jsonRelated["item_id_related"]);

        }
      });

      data.itemRelated = arrayRelated;
      data.itemId = adminCrmItems.rowIdSelected;
      console.log(data.itemId);
      itemServices.insertRelated(data, function (result) {
        itemServices.getAllRelated(adminCrmItems.rowIdSelected, ln, function (
          result
        ) {
          adminCrmItems.tableDataRelated = result.data;

          spinnerHelpers.hide();
        });
      });
    },*/

    onChangeCheckRelated(idItems) {
    var adminCrmItems = this;  
    if ($("#checkbox" + idItems).is(":checked")) {

      var data = {
          idItems: idItems,
          rowIdSelected: this.rowIdSelected,
        };
      /* insert */
       itemServices.insertRelated(data, function (result) { 
        
        notificationHelpers.success(adminCrmItems.insertCompleted); 
      }); 
    } else {
       /* delete */
       itemServices.delRelated(idItems, adminCrmItems.rowIdSelected, function (result) {
        
        notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted")); 
      });
    }
  },


    confirmSaveCategories() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveCategoriesSave();
      }
    },

    executeSaveCategoriesSave() {
      spinnerHelpers.show();
      var adminCrmItems = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableCategories.getRowSelected(), function (i, row) {
        var rowToSave = row;
        rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
        rowToSave.idLanguage = adminCrmItems.languages;
        adminCrmItems.rowsSelected = adminCrmItems.rowsSelected + 1;
        // rowToSave.idlanguage=adminCrmItems.languages;
        itemServices.update(
          rowToSave,
          function () {
            adminCrmItems.checkAllIsSaved();
            adminCrmItems.tableResult.push({
              id: rowToSave.id,

              success: true,
            });
            notificationHelpers.success(adminCrmItems.updateCompleted);
            $("#detailItem").addClass("active");
            $("#detailItemsList").removeClass("active");
            $("#detailCategories").removeClass("active");
            $("#detailItemRelated").removeClass("active");
            $("#DetailAttribute").removeClass("active");
            $("#DetailCommercial").removeClass("active");
            $("#DetailOptions").removeClass("active");
            $("#DetailSale").removeClass("active");
            $("#detailTranslations").removeClass("active");
            $("#DetailOptional").removeClass("active");
            $("#DetailListCategories").removeClass("active");
            $("#DetailImages").removeClass("active");
          },
          function (response) {
            adminCrmItems.checkAllIsSaved();
            adminCrmItems.tableResult.push({
              id: rowToSave.id,
              success: false,
              message: response,
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    /***   ITEMS   ****/

    onItemRelatedTab: function () {
      var adminCrmItems = this;
      $("#detailItem").removeClass("active");
      // $("#detailItemRelated").addClass("active");
      $("#detailItemsList").removeClass("active");
      $("#detailCategories").addClass("active");
      $("#DetailAttribute").removeClass("active");
      $("#DetailCommercial").removeClass("active");
      $("#DetailOptions").removeClass("active");
      $("#DetailSale").removeClass("active");
      $("#detailTranslations").removeClass("active");
      $("#DetailOptional").removeClass("active");
      $("#DetailListCategories").removeClass("active");
      $("#DetailImages").removeClass("active");
    },

    onItemRelatedDisableTab: function () {
      var adminCrmItems = this;
      $("#detailItem").addClass("active");
      $("#detailItemsList").removeClass("active");
      $("#detailCategories").removeClass("active");
      $("#detailItemRelated").removeClass("active");
      $("#DetailAttribute").removeClass("active");
      $("#DetailCommercial").removeClass("active");
      $("#DetailOptions").removeClass("active");
      $("#DetailSale").removeClass("active");
      $("#detailTranslations").removeClass("active");
      $("#DetailOptional").removeClass("active");
      $("#DetailListCategories").removeClass("active");
      $("#DetailImages").removeClass("active");
    },

    onAddRelatedItem: function () {
      var adminCrmItems = this;
      $("#tableItemRelated").removeClass("active");
      $("#detailCategories").removeClass("active");
      $("#DetailAttribute").removeClass("active");
      $("#DetailCommercial").removeClass("active");
      $("#DetailOptions").removeClass("active");
      $("#DetailSale").removeClass("active");
      $("#detailTranslations").removeClass("active");
      $("#DetailOptional").removeClass("active");
      $("#DetailListCategories").removeClass("active");
      $("#DetailImages").removeClass("active");
    },
    loadTranslation() {
      var adminCrmItems = this;
      itemServices.getItemLanguages(adminCrmItems.rowIdSelected, function (result) {
        adminCrmItems.itemLanguages = result.data.selectItemExist;
        if(result.data.totalLn == result.data.totalLnItemsPresent){
          adminCrmItems.noMoreTranslate = true;
        }else{
          adminCrmItems.noMoreTranslate = false;
        }
      });
    },
    onTabAdminItemstranslation: function () {
      var adminCrmItems = this;
      adminCrmItems.loadTranslation();

      $("#detailTranslations").addClass("active");
      $("#detailItemsList").removeClass("active");
      $("#detailCategories").removeClass("active");
      $("#detailItemRelated").removeClass("active");
      $("#DetailAttribute").removeClass("active");
      $("#DetailCommercial").removeClass("active");
      $("#DetailOptions").removeClass("active");
      $("#DetailSale").removeClass("active");
      $("#detailItem").removeClass("active");
      $("#DetailOptional").removeClass("active");
      $("#DetailListCategories").removeClass("active");
      $("#DetailImages").removeClass("active");
    },

    onTabAdminItemsAttribute: function () {
      var adminCrmItems = this;
      itemServices.getByImgAgg(adminCrmItems.rowIdSelected, function (result) {
        var j = 0;
        var imgAggAttachment = [];
        adminCrmItems.files = [];
        imgAggAttachment = result.data;

        if (imgAggAttachment.length > 0) {
          adminCrmItems.cont = imgAggAttachment.length;
          for (var j = 0; j < imgAggAttachment.length; j++) {
            var jsonAttachment = {};
            jsonAttachment["idAttachment"] = imgAggAttachment[j].id;
            jsonAttachment["id"] = j;
            jsonAttachment["name"] = imgAggAttachment[j].img_attachment;
            jsonAttachment["size"] = "0";

            adminCrmItems.files.push(jsonAttachment);
          }
        }

        $(".imgAggInput").on("change", function (e) {
          var el = $(this).parent("div").parent("div").attr("data-id-img-agg");
          var reader = new FileReader();
          var files = e.target.files || e.dataTransfer.files;
          var jsonImgAgg = {};
          if (!files.length) return;
          reader.onload = (e) => {
            $("#imgName" + el).val(files[0].name);
            $("#imgBase64" + el).val(e.target.result);
          };
          reader.readAsDataURL(files[0]);
        });

        $("#DetailAttribute").addClass("active");
        $("#detailItemsList").removeClass("active");
        $("#detailCategories").removeClass("active");
        $("#detailItem").removeClass("active");
        $("#detailItemRelated").removeClass("active");
        $("#DetailCommercial").removeClass("active");
        $("#DetailOptions").removeClass("active");
        $("#DetailSale").removeClass("active");
        $("#detailTranslations").removeClass("active");
        $("#DetailOptional").removeClass("active");
        $("#DetailListCategories").removeClass("active");
        $("#DetailImages").removeClass("active");
      });
    },

    onTabAdminPriceList: function () {
      var adminCrmItems = this;

      itemServices.getByPriceList(adminCrmItems.rowIdSelected, function (
        result
      ) {
        var AggPriceList = result.data;
        if (AggPriceList.length > 0) {
          adminCrmItems.cont = AggPriceList.length;
          $("#div-cont-img-agg").html("");
          for (var j = 0; j < AggPriceList.length; j++) {
            var html = "";
            if (j < 50) {
              html +=
                '<div class="row" style="margin-bottom: 10px;" data-id-row="' +
                adminCrmItems.cont +
                '" id="divcont-' +
                adminCrmItems.cont +
                '" >';
              html += '<div class="col-8">';
              html +=
                '<select class="custom-select pricelist_id" style="width:100%!important;" id="pricelist_id' +
                j +
                '" value="' +
                AggPriceList[j].pricelist_id +
                '" name="pricelist_id' +
                j +
                '"></select>';
              html += "</div>";
              html += '<div class="col-4 style="padding-left: 30px;"">';
              html +=
                '<input type="text" class="form-control pricelist" style="margin-left: -1px; width:60px;" id="pricelist' +
                j +
                '" value="' +
                AggPriceList[j].pricelist +
                '" name="pricelist' +
                j +
                '">';
              html += "</div>";
              html += "</div>";
              $("#div-cont-img-agg").append(html);

              var searchParam = "";
              var initials = [];
              initials.push({
                id: AggPriceList[j].pricelist_id,
                text: AggPriceList[j].pricelistDescription,
              });
              $("#pricelist_id" + j).select2({
                data: initials,
                ajax: {
                  url: configData.wsRootServicesUrl + "/api/v1/list/select",
                  data: function (params) {
                    if (params.term == "") {
                      searchParam = "*";
                    } else {
                      searchParam = params.term;
                    }
                    var query = {
                      search: searchParam,
                    };
                    return query;
                  },
                  processResults: function (data) {
                    var dataParse = JSON.parse(data);
                    return {
                      results: dataParse.data,
                    };
                  },
                },
              });
            }
          }
        }
        $("#DetailSale").addClass("active");
        $("#DetailOptions").removeClass("active");
        $("#detailItemRelated").removeClass("active");
        $("#detailItem").removeClass("active");
        $("#DetailAttribute").removeClass("active");
        $("#DetailCommercial").removeClass("active");
        $("#detailCategories").removeClass("active");
        $("#detailTranslations").removeClass("active");
        $("#DetailListCategories").removeClass("active");
        $("#DetailOptional").removeClass("active");
        $("#DetailImages").removeClass("active");
      });
    },
    onTabAdminItemsOptional: function () {
      var adminCrmItems = this;
      $("#DetailOptions").removeClass("active");
      $("#detailItemRelated").removeClass("active");
      $("#detailItem").removeClass("active");
      $("#DetailAttribute").removeClass("active");
      $("#DetailCommercial").removeClass("active");
      $("#DetailOptional").addClass("active");
      $("#DetailListCategories").removeClass("active");
      $("#DetailImages").removeClass("active");
      $("#DetailSale").removeClass("active");
      $("#detailTranslations").removeClass("active");
      $("#detailCategories").removeClass("active");

      adminCrmItems.loadOptional();
    },
    onItemListCategoriesTab: function () {
      var adminCrmItems = this;
      $("#DetailOptions").removeClass("active");
      $("#detailItemRelated").removeClass("active");
      $("#detailItem").removeClass("active");
      $("#DetailAttribute").removeClass("active");
      $("#DetailCommercial").removeClass("active");
      $("#DetailOptional").removeClass("active");
      $("#DetailImages").removeClass("active");
      $("#DetailSale").removeClass("active");
      $("#detailTranslations").removeClass("active");
      $("#detailCategories").removeClass("active");
      $("#DetailListCategories").addClass("active");

      adminCrmItems.loadListCategories();
      adminCrmItems.loadDetailListCategories();
    },
    onItemAdminImagesTab: function () {
      var adminCrmItems = this;
      $("#DetailOptions").removeClass("active");
      $("#detailCategories").removeClass("active");
      $("#detailItemRelated").removeClass("active");
      $("#detailItem").removeClass("active");
      $("#DetailAttribute").removeClass("active");
      $("#DetailCommercial").removeClass("active");
      $("#DetailOptional").removeClass("active");
      $("#DetailListCategories").removeClass("active");
      $("#DetailImages").addClass("active");
      $("#DetailSale").removeClass("active");
      $("#detailTranslations").removeClass("active");

      adminCrmItems.loadItemImages(adminCrmItems.detailData);
    },
    confirmSaveNewCategories() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveNewCategories();
      }
    },

    executeSaveNewCategories() {
      spinnerHelpers.show();
      var arrayPrice = [];
      var jsonPrice = {};
     // jsonPrice["pricelist_id"] = $("#pricelist_id").val();
     // jsonPrice["pricelist"] = $("#pricelist").val();
     // arrayPrice.push(jsonPrice);
      for (var i = 0; i < 50; i++) {
        jsonPrice = {};

        if (functionHelpers.isValued($("#pricelist_id" + i).val())) {
          jsonPrice["pricelist_id"] = $("#pricelist_id" + i).val();
        }

        if (functionHelpers.isValued($("#pricelist" + i).val())) {
          jsonPrice["pricelist"] = $("#pricelist" + i).val();
        }

        if (
          functionHelpers.isValued($("#pricelist_id" + i).val()) &&
          functionHelpers.isValued($("#pricelist" + i).val())
        ) {
          arrayPrice.push(jsonPrice);
        }
      }
      this.detailData.pricelist = arrayPrice;
      

      var arrayImgAgg = [];
      // var jsonImgAgg = {};

      //jsonImgAgg["img"] = $("#img").val();
      // arrayImgAgg.push(jsonImgAgg);

      for (var i = 0; i < 10; i++) {
        var jsonImgAgg = {};

        if (functionHelpers.isValued($("#imgName" + i).val())) {
          jsonImgAgg["imgName"] = $("#imgName" + i).val();
        }

        if (functionHelpers.isValued($("#imgBase64" + i).val())) {
          jsonImgAgg["imgBase64"] = $("#imgBase64" + i).val();
        }
        if (functionHelpers.isValued($("#img" + i).val())) {
          jsonImgAgg["img"] = $("#img" + i).val();
        }

        if (
          functionHelpers.isValued($("#imgBase64" + i).val()) &&
          functionHelpers.isValued($("#imgName" + i).val()) &&
          functionHelpers.isValued($("#img" + i).val())
        ) {
          arrayImgAgg.push(jsonImgAgg);
        }
      }
      this.detailData.imgAgg = arrayImgAgg;

      var ImgArrayFiles = [];

      for (var i = 0; i < 10; i++) {
        var jsonImgFiles = {};

        if (functionHelpers.isValued($("#name" + i).val())) {
          jsonImgFiles["name"] = $("#name" + i).val();
        }
        if (functionHelpers.isValued($("#file" + i).val())) {
          jsonImgFiles["file"] = $("#file" + i).val();
        }
        if (functionHelpers.isValued($("#name" + i).val())) {
          ImgArrayFiles.push(jsonImgFiles);
        }
      }
      this.detailData.filesUpload = ImgArrayFiles;

      var adminCrmItems = this;
      this.detailData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (!functionHelpers.isValued(this.detailData.code)) {
        this.detailData.code = false;
      }

      if (!functionHelpers.isValued(this.languages)) {
        this.detailData.idLanguage = storageData.sIdLanguage();
      } else {
        this.detailData.idLanguage = this.languages;
      }

      if (
        functionHelpers.isValued(this.rowIdSelected) &&
        this.rowIdSelected > 0
      ) {
        this.detailData.id = this.rowIdSelected;

        itemServices.update(this.detailData, function (result) {
          adminCrmItems.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmItems.updateCompleted,
          });
          notificationHelpers.success(adminCrmItems.updateCompleted);
          adminCrmItems.loadTable(adminCrmItems.languages);
          $("#tabTable").addClass("active");
          $("#tabDetail").removeClass("active");
        });
      } else {
        itemServices.insert(this.detailData, function (result) {
          adminCrmItems.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmItems.insertCompleted,
          });
          notificationHelpers.success(adminCrmItems.insertCompleted);
          adminCrmItems.loadTable(adminCrmItems.languages);
          $("#tabTable").addClass("active");
          $("#tabDetail").removeClass("active");
        });
      }
    },
    confirmDeleteCategories() {
          if (confirm("Sei sicuro di voler eliminare?")) {
        this.executeDeleteCategories();
      }
    },
    executeDeleteCategories() {
      spinnerHelpers.show();
      var adminCrmItems = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableCategories.getRowSelected(), function (i, row) {
        adminCrmItems.rowsSelected = adminCrmItems.rowsSelected + 1;

        itemServices.del(
          row.id,
          function () {
            adminCrmItems.checkAllIsSaved();
            notificationHelpers.success(adminCrmItems.deleteCompleted);
          },
          function (response) {
            adminCrmItems.checkAllIsSaved();
            adminCrmItems.tableResult.push({
              id: rowToSave.id,
              success: false,
              message: response,
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    onTableCheckCategories() {
      var countRowSelected = this.$refs.tableCategories.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },

    confirmCancelNewCategories() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmCancel"))) {
        this.executeCancelCategories();
      }
    },

    executeCancelCategories() {
      spinnerHelpers.show();
      this.detailTemplateEditorData = {};
      this.rowIdSelected = 0;
      $("#tabTable").addClass("active");
      $("#tabDetail").removeClass("active");

      spinnerHelpers.hide();
    },

    checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.disableButton = true;
        this.loadTable(this.languages);
      }
    },
    /* FUNCTION OPTIONAL */
    loadOptional() {
      var adminCrmItems = this;
      var ln = storageData.sIdLanguage();
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }
      typeOptionalServices.getAllTypeAndOptional(ln,adminCrmItems.rowIdSelected,function (result) {
        adminCrmItems.arrayOptional = result.data;
      });
      setTimeout(function(){
        for(var i = 0; i < adminCrmItems.arrayOptional.length; i++){
          for(var z = 0; z< adminCrmItems.arrayOptional[i].optional.length; z++){
            for(var y = 0; y < adminCrmItems.arrayOptional[i].optional[z].length; y++){
              if(adminCrmItems.arrayOptional[i].optional[z][y].checkItemSupport){
                
                var url = configData.wsRootServicesUrl + '/api/v1/UnitMeasure/select';
                var searchParam = "";
                var initials = [];
                if(adminCrmItems.arrayOptional[i].optional[z][y].umSupportVariationId != '' && adminCrmItems.arrayOptional[i].optional[z][y].umSupportVariationId != null){
                  initials.push({
                    id: adminCrmItems.arrayOptional[i].optional[z][y].umSupportVariationId,
                    text: adminCrmItems.arrayOptional[i].optional[z][y].umSupportVariationDescription
                  });
                }else{
                  initials.push({
                    id: '',
                    text: '- Seleziona -'
                  });
                }
                
                $('#umSupportVariationId' + adminCrmItems.arrayOptional[i].optional[z][y].id).select2({
                  data: initials,
                  ajax: {
                    url: url,
                    data: function (params) {
                      if(params.term==''){
                        searchParam = '*';
                      }else{
                        searchParam = params.term;
                      }
                      var query = {
                      search: searchParam
                      }
                      return query;
                    },
                    processResults: function (data) {
                      var dataParse = JSON.parse(data);
                      return {
                        results: dataParse.data
                      };
                    }
                  }
                }); 
              } 
            }  
          }
        }
      }, 500);
    },
    confirmSaveOptional() {
      spinnerHelpers.show();
      var adminCrmItems = this;
      var data = {};
      var arrayOptional = [];

      $(".div-row-optional").each(function (index) {
        var idOptional = $(this).attr("data-id-optional");
        if ($("#switchOptional" + idOptional).is(":checked")) {
          var jsonOption = {};
          jsonOption["item_id"] = adminCrmItems.rowIdSelected;
          jsonOption["optional_id"] = idOptional;
          jsonOption["variation_price"] = $("#variation" + idOptional).val();
          jsonOption["availability"] = $("#availability" + idOptional).val();
          jsonOption["variation_type"] = $(
            'input[name="radio' + idOptional + '"]:checked'
          ).val();
          jsonOption["umSupportVariationId"] = $("#umSupportVariationId" + idOptional).val();
          jsonOption["supportParameter"] = $("#supportParameter" + idOptional).val();
          if($("#supportVariationValue" + idOptional).val()!= '' && $("#supportVariationValue" + idOptional).val() != undefined){
            jsonOption["supportVariationValue"] = $("#supportVariationValue" + idOptional).val().replace(',','.');
          }else{
            jsonOption["supportVariationValue"] = '';
          }
          

          arrayOptional.push(jsonOption);
        }
      });
      data.item_id = adminCrmItems.rowIdSelected;
      data.optional = arrayOptional;
      optionalServices.insertItemOptional(data, function (result) {
        spinnerHelpers.hide();
        adminCrmItems.loadOptional();
      });
    },
    onChangeSelectedTypeOptional(idTypeOptional) {
      var adminCrmItems = this;
      if ($("#switchTypeOptional" + idTypeOptional).is(":checked")) {
        /* insert item optional */
        var data = {
          idTypeOptional: idTypeOptional,
          idItem: adminCrmItems.rowIdSelected,
        };
        typeOptionalServices.insertItemTypeOptional(data, function (result) {
          adminCrmItems.loadOptional();
        });
      } else {
        /* delete item optional */
        typeOptionalServices.delItemTypeOptional(
          idTypeOptional,
          adminCrmItems.rowIdSelected,
          function (result) {
            adminCrmItems.loadOptional();
          }
        );
      }
    },
    onChangeSelectedOptional(idOptional) {
      var adminCrmItems = this;
      if ($("#switchOptional" + idOptional).is(":checked")) {
        $("#optionList" + idOptional).css("display", "inline-block");
      } else {
        $("#optionList" + idOptional).hide();
      }
    },
    /* END FUNCTION OPTIONAL */
    /* FUNCTION LIST CATEGORIES */
    loadListCategories() {
      spinnerHelpers.show();
        var ln = storageData.sIdLanguage();
        var adminCrmItems = this;
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
      categoriesServices.getAllListNavigation(ln,adminCrmItems.rowIdSelected, function (result) {
          adminCrmItems.listTreeCategories = result.data;
          spinnerHelpers.hide();
        });
    },
    checkCategoriesClick(id, checkedCategories) {
      var adminCrmItems = this;

      var data = {
        idCategories: id,
        idItem: adminCrmItems.rowIdSelected,
      };
      if (checkedCategories) {
        itemServices.insertItemCategories(data, function (result) {
          adminCrmItems.loadDetailListCategories();
          notificationHelpers.success("Articolo aggiunto alla categoria selezionata");
        });
      } else {
        itemServices.deleteItemCategories(
          id,
          adminCrmItems.rowIdSelected,
          function (result) {
            adminCrmItems.loadDetailListCategories();
            notificationHelpers.success(
              "Articolo rimosso dalla categoria selezionata"
            );
          }
        );
      }
    },
    loadDetailListCategories() {
      var ln = storageData.sIdLanguage();
      var adminCrmItems = this;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }
      categoriesServices.getAllDetailListCategories(
        ln,
        adminCrmItems.rowIdSelected,
        function (result) {
          adminCrmItems.arrayListCategoriesDetail = result.data;
        }
      );
    },
    updateOrderCategoryItem(id) {
      var adminCrmItems = this;
      var data = {
        idItem: adminCrmItems.rowIdSelected,
        idCategories: id,
        order: $("#inputOrder" + id).val(),
      };

      categoriesServices.updateOrderCategoryItem(data, function (result) {
        adminCrmItems.loadDetailListCategories();
        notificationHelpers.success("Ordinamento aggiornato");
      });
    },
    /* END FUNCTION LIST CATEGORIES */
    /* FUNCTION IMAGES */
    loadItemImages() {
      var adminCrmItems = this;
      itemServices.getImages(adminCrmItems.rowIdSelected, function (result) {
        adminCrmItems.itemImages = result.data;
        if(!adminCrmItems.scriptGallery){
          $.getScript("https://cdn.rawgit.com/sachinchoolur/lightgallery.js/master/dist/js/lightgallery.js").done(function(){
            adminCrmItems.scriptGallery = true;
            $.getScript("https://cdn.jsdelivr.net/picturefill/2.3.1/picturefill.min.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-share.js/master/dist/lg-share.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-pager.js/master/dist/lg-pager.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-autoplay.js/master/dist/lg-autoplay.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-fullscreen.js/master/dist/lg-fullscreen.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-zoom.js/master/dist/lg-zoom.js");
            $.getScript("https://cdn.rawgit.com/sachinchoolur/lg-hash.js/master/dist/lg-hash.js");
            /*lightGallery(document.getElementById('lightgallery'));*/
            lightGallery(document.getElementById('DetailImages'), {
              selector : '.img'
            }); 
          });
        }
      });
    },
    deleteImage(isPrincipalImage, id) {
      var adminCrmItems = this;
      if (
        confirm("Sei sicuro di voler eliminare l'associazione dell'immagine?")
      ) {
        if (isPrincipalImage) {
          //update imgName = '' in items.imgName by id
          var data = {
            idItem: adminCrmItems.rowIdSelected,
            imgName: "",
            imgBase64: "",
          };

          itemServices.updateImageName(data, function (result) {
            adminCrmItems.loadItemImages();
            notificationHelpers.success("Eliminazione avvenuta correttamente");
          });
        } else {
          //delete itemphotos by itemphotos.id
          itemServices.deleteItemsPhotos(id, function (result) {
            adminCrmItems.loadItemImages();
            notificationHelpers.success("Eliminazione avvenuta correttamente");
          });
        }
      }
    },
    onChangeOrderImagePhoto(id) {
      var adminCrmItems = this;
      var data = {
        id: id,
        order: $("#inputOrderImgAgg" + id).val(),
      };
      itemServices.updateOrderImamePhotos(data, function (result) {
        adminCrmItems.loadItemImages();
        notificationHelpers.success("Ordinamento aggiornato con successo");
      });
    },
    selectImages() {
      /* creare api per viualizzare tutte le foto ptrsenti in una determinata cartella su webApi */
    },
    onChangeImagePrincipalNew(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImagePrincipalNew(e.target.id, files[0].name, files[0]);
    },
    createImagePrincipalNew(id, name, file) {
      var adminCrmItems = this;
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        /*adminCrmItems.itemImages.img = e.target.result;
        adminCrmItems.itemImages.imgName = name;*/
        var data = {
          idItem: adminCrmItems.rowIdSelected,
          imgName: name,
          imgBase64: e.target.result,
        };

        itemServices.updateImageName(data, function (result) {
          adminCrmItems.loadItemImages();
          notificationHelpers.success(
            "Immagine principale inserita con successo"
          );
        });
      };

      reader.readAsDataURL(file);
    },
    onChangeImageAgg(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      for (var i = 0; i < files.length; i++) {
        this.createImageAgg(e.target.id, files[i].name, files[i]);
      }
    },
    createImageAgg(id, name, file) {
      var adminCrmItems = this;
      var jsonImgAggUpload = this;
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        var data = {
          idItem: adminCrmItems.rowIdSelected,
          imgName: name,
          imgBase64: e.target.result,
        };

        itemServices.insertItemImages(data, function (result) {
          adminCrmItems.loadItemImages();
          notificationHelpers.success(
            "Immagine aggiuntiva inserita con successo"
          );
        });
      };

      reader.readAsDataURL(file);
    },
    selectImageExist(id, isPrincipal) {
      var adminCrmItems = this;
      adminCrmItems.idImageSelectedToReplaceImage = id;
      var data = {
        page : adminCrmItems.pageImage,
        search : $('#modalImgBlogForm #search').val(),
        month : $('#modalImgBlogForm #month').val(),
        year : $('#modalImgBlogForm #year').val(),
      };
      adminCrmItems.selectedChangePrincipalImage = isPrincipal;
      //itemServices.getAllImagesInFolder(id, function (result) {
      pageServices.getByFile(data, function (result) {
        /*$('#ul-image').css('max-height', window.innerHeight - 200);
        adminCrmItems.arrayAllImagesExistFolder = result.data;*/
        $("#modalImageExistFolder").modal("show");

        if(result.data.length>0){
          if(adminCrmItems.arrayAllImagesExistFolder.length == 0 || adminCrmItems.pageImage == 1){
            adminCrmItems.arrayAllImagesExistFolder = result.data;
            $('#ul-image').css('max-height', window.innerHeight - 200);
          }else{
            var array1 = adminCrmItems.arrayAllImagesExistFolder;
            var array2 = result.data;
            var newArray = array1.concat(array2);
            adminCrmItems.arrayAllImagesExistFolder = newArray;
          }
        }
      });
    },
    selectReplaceImageExist(id, img) {
      var adminCrmItems = this;
      if (!adminCrmItems.selectedChangePrincipalImage) {
        var data = {
          idItem: adminCrmItems.rowIdSelected,
          idItemPhotos: id,
          imgName: img,
          imgBase64: "",
        };

        itemServices.updateItemImages(data, function (result) {
          $("#modalImageExistFolder").modal("hide");
          adminCrmItems.loadItemImages();
          notificationHelpers.success("Immagine sostituita correttamente");
        });
      } else {
        var data = {
          idItem: adminCrmItems.rowIdSelected,
          imgName: img,
          imgBase64: "",
        };

        itemServices.updateImageName(data, function (result) {
          $("#modalImageExistFolder").modal("hide");
          adminCrmItems.loadItemImages();
          notificationHelpers.success(
            "Immagine principale aggiornata con successo"
          );
        });
      }
    },
    onChangeAssociationCodeImage() {
      var adminCrmItems = this;
      //adminCrmItems.checkAssociationCodeImage = false;
      if (adminCrmItems.checkAssociationCodeImage) {
        adminCrmItems.checkAssociationCodeImage = false;
      }else{
        adminCrmItems.checkAssociationCodeImage = true;
      }
      var data = {
        idItem: adminCrmItems.rowIdSelected,
        checkAssociationCodeImage: adminCrmItems.checkAssociationCodeImage,
      };

      itemServices.updateItemCheckAssociation(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
      });
    },
    /* END FUNCTION IMAGES */
    onChangeCheckOnlineItem() {
      var adminCrmItems = this;
      var data = {
        idItem: adminCrmItems.rowIdSelected,
      };
      itemServices.updateOnlineItem(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
      });
    },
    onChangeCheckOnlineItemList(id) {
      var adminCrmItems = this;
      var data = {
        id: id,
      };
      itemServices.updateOnlineItemCheck(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
      });
    },
    onChangeCheckAnnouncementsItemList(id) {
      var adminCrmItems = this;
      var data = {
        id: id,
      };
      itemServices.updateAnnouncementsItemCheck(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
      });
    },
    onChangeCheckPromotionItemList(id) {
      var adminCrmItems = this;
      var data = {
        id: id,
      };
      itemServices.updatePromotionItemCheck(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
      });
    },
    /* SUPPORTI */
    onChangeSupportItem(id){
      var adminCrmItems = this;
      var data = {
        idSupport : id,
        idItem : adminCrmItems.rowIdSelected
      }
      supportsServices.insertItemSupport(data, function (result) {
        if(result.data > 0){
          notificationHelpers.success("Collegamento al supporto avvenuto correttamente!");
        }else{
          notificationHelpers.success("Rimozione collegamento al supporto avvenuta correttamente!");
        }
      });
    }
    /* END SUPPORTI */
  },
};
</script>
<style scoped>

@import url('https://cdn.rawgit.com/sachinchoolur/lightgallery.js/master/dist/css/lightgallery.css');
.card-title-admin .card {
  background: transparent;
  border: 0px;
}
.card-title-admin h1 {
  font-size: 40px;
  font-weight: lighter;
  color: #303c54;
}

.align-btns {
 position: absolute;
    z-index: 1;
    margin-top: 10px;
}

.buttonsave {
  text-align: left;
  /*margin-left: 651px;*/
}

.button-add {
  text-align: left;
  /*margin-left: 1008px;*/
}

.buttonSearch {
  margin-top: 7px;
  margin-left: 411px;
}

body,
html {
  height: 100%;
}
main {
  margin-top: 30px;
  height: 100%;
}
.container {
  border: 2px dashed pink;
  min-height: 150px;
}
#app {
  border: 1px solid white;
  height: 30vh;
}
.file-wrapper {
  text-align: center;
  font-family: "Quicksand", sans-serif;
  width: 300px;
  height: 5em;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  overflow: hidden;
  background: white;

  max-width: 322px;

  padding: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 20px;
  cursor: pointer;
  color: #cccccc;
  border-radius: 10px;
}

.file-wrapper input {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  font-size: 300px;
  height: 200px;
}

.custom-file-upload {
  padding: 20px;
  cursor: pointer;
  width: 100%;
  text-align: center;
  font-weight: lighter;
  border: 3px dashed #ededed;
  border-radius: 10px;
  color: slategrey;
}
#imgAttachmentAgg[type="file"] {
  display: none;
}

.padding {
  /*width: 951.988636px;*/
}

.button-copylanguage-default {
  margin-left: 676px;
}
.row-single-optional:hover{
  background:#ededed;
}
.row-type-optional {
  margin-top: 15px;
  margin-bottom: 20px;
}
.row-type-optional p {
  font-size: 20px;
  font-weight: lighter;
  color: #303c54;
  display: inline-block;
  margin-right: 25px;
  margin-left: 5px;
}
.option-description {
  font-size: 15px !important;
  font-weight: lighter;
  color: #303c54;
  display: inline-block;
  margin-right: 25px;
  margin-left: 5px;
}
.input-optional {
  max-width: 70px;
}
.label-option {
  margin-right: 25px;
  color: #303c54;
  font-size: 14px;
  font-weight: lighter;
}
.listDetailCategories {
  padding: 10px 0px 10px 0px;
  border-bottom: 4px dashed #ededed;

}
.listDetailCategories:first-child {
  border-top: 4px dashed #ededed;
}
.listDetailCategories label {
  color: #303c54;
  font-size: 14px;
  font-weight: lighter;
}
.listDetailCategories h5 {
  font-size: 15px;
  font-weight: bold;
  color: #303c54;
}
.div-row-img-item label {
  color: #303c54;
  font-size: 14px;
  font-weight: lighter;
}
.div-row-img-item {
  padding-top: 10px;
  padding-bottom: 10px;
}
.div-row-img-item img {
  max-height: 50px;
}
.label-name {
  margin-left: 10px;
}
.div-row-img-item .fa-trash {
  color: red;
  float: right;
  margin-top: 5px;
  margin-right: 5px;
}
.fa-trash {
  color: red;
}

.trashtable {
   color: #fff!important;
}

.div-row-img-item .form-control {
  float: left;
  width: 85%;
}
/* style for upload area */
#imgPrincipalItems[type="file"] {
  display: none;
}
#imgPrincipalAgg[type="file"] {
  display: none;
}
.custom-file-upload {
  padding: 20px;
  cursor: pointer;
  width: 100%;
  text-align: center;
  border: 3px dashed #ededed;
  border-radius: 10px;
}
/* end style for upload area */

.previewImageExistFolder {
  max-width: 100%;
  max-height: 150px;
}
.contPreviewImageExistFolder {
  padding: 15px;
  margin: 2px;
  border: 2px solid #ededed;
  cursor: pointer;
}
/* related */
#detailCategories label {
  font-size: 15px;
  font-weight: bold;
  color: #303c54;
  display: inline-block;
  margin-right: 25px;
  margin-left: 5px;
}
.div-row-related,
.div-row-translation {
  padding-top: 7px;
  padding-bottom: 7px;
  border-bottom: 1px solid #ededed;
}
.div-row-related span {
  color: #303c54;
  font-size: 14px;
  font-weight: lighter;
}

/* end related */
/* translate */
#detailTranslations label {
  font-size: 15px;
  font-weight: bold;
  color: #303c54;
  display: inline-block;
  margin-right: 25px;
}
.div-row-translation span {
  color: #303c54;
  font-size: 14px;
  font-weight: lighter;
}

.div-row-translation .translate-characteristic {
  max-height: 70px;
  overflow: auto;
}

/* end translate */
.nav-tabs .nav-item {
  width: 12.5%;
}
.nav-tabs .nav-link {
  width: 100%;
  border-radius: 0;
  color: #fff;
  background: #3c4b64;
  border-bottom: 3px solid #f45f00 !important;
  border: 0px;
}
.nav-tabs .nav-link.active {
  background: #2a3545 !important;
}
.nav-tabs > .nav-item > .nav-link:not(.active) {
  background: #3c4b64 !important;
}

.language {
    height: 37px!important;
}

.select2-container--default .select2-selection--single .select2-selection__arrow b {
    margin-top: 3px!important;
}

#descriptionsearc{
  height: 56px;
}
#internal_codesearc{
  height: 56px;
}

#category_idsearc .select2{
  height: 56px;
}
span.select2-container select2-container--default {
  height: 56px;
}

#language {
height: 55px!important;
}

/* popup image */

#ul-image{
  width: 100%;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  max-height: 50px;
  overflow:auto;
}
.listLi {
  list-style: none;
  text-align: center;
}
.list-group-item{
  margin-bottom: 5px;
  height: 105px;
  padding: 0px;
  background: #ededed;
  border-radius: 0px;
}
.labelListImage {
  cursor: pointer;
  font-size: 12px;
  padding: 2px;
  position: absolute;
  left: 0;
  top: 0px !important;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  background: rgba(255,255,255,0.7);
}
.div-extension-img{
    position: absolute;
    bottom: 0px;
    left: 0px;
    background: #238AE6;
    border-radius: 5px;
    padding-left: 5px;
    padding-right: 5px;
    box-shadow: 0px 0px 7px -2px rgb(0 0 0 / 30%);
}

.div-extension-img label {
    font-size: 10px;
    margin: 0px !important;
    display: block;
    color: #fff;
    font-weight: bold;
}
/* end popup image */

</style>
